import LocalizedStrings from 'localized-strings';

const strings = new LocalizedStrings({
  en: {
    shared: {
      app: {
        name: 'FortPac',
        support: 'Contact FortPac Support'
      },
      buttons: {
        previous: 'Previous',
        next: 'Next'
      },
      dataTable: {
        multipleSelectionMenuItems: {
          itemsOnPage: 'Select {number} items on this page',
          allItems: 'Select all {number} items',
          clearSelection: 'Unselect All'
        }
      },
      login: {
        welcome: 'Growing People And Companies',
        button: 'Please, log in with your Microsoft account by clicking the button below'
      },
      ui: {
        accuracy: 'Accuracy',
        add: 'Add',
        all: 'All',
        approve: 'Approve',
        awesome: 'Awesome',
        back: 'Back',
        backToTop: 'Back to Top',
        cancel: 'Cancel',
        clear: 'Clear',
        clearAll: 'Clear All',
        close: 'Close',
        confirm: 'Please confirm',
        singleConfirm: 'Confirm',
        continue: 'Continue',
        copiedToClipboard: 'Copied to clipboard',
        copyToClipboardFailed: 'Failed to copy to clipboard',
        copy: 'Copy',
        dislike: 'Dislike',
        download: 'Download',
        edit: 'Edit',
        error: 'Error',
        fillIn: 'Fill In',
        filters: 'Filters',
        form: 'Form',
        goBack: 'Go Back',
        gotIt: 'Got it',
        hideFilters: 'Hide Filters',
        applyFilters: 'Apply Filters',
        keepDeleteButtonCopies: {
          cancelButtonText: 'Keep',
          confirmButtonText: 'Delete'
        },
        keepRemoveButtonsCopies: {
          cancelButtonText: 'Keep',
          confirmButtonText: 'Remove'
        },
        like: 'Like',
        moreActions: 'More Actions',
        no: 'No',
        ok: 'Ok',
        read: 'Read',
        refresh: 'Refresh',
        reset: 'Reset {item}',
        resetAll: 'Reset all',
        restart: 'Restart',
        retry: 'Retry',
        save: 'Save',
        saving: 'Saving',
        saved: 'Saved',
        saveAsDraft: 'Save as Draft',
        search: 'Search',
        searching: 'Searching ...',
        selectFile: 'Select a File',
        send: 'Send',
        sending: 'Sending',
        settings: 'Settings',
        showFilters: 'Show Filters',
        submit: 'Submit',
        typeToFind: 'Type to find something',
        unknownError: {
          title: 'Something went wrong',
          body: 'Please copy the following information and report it to',
          targetGlip: `Fortpac Support's Glip`,
          action: 'Go Back',
          diagnosticsError: 'Error',
          diagnosticsUrl: 'URL',
          version: 'Version'
        },
        unread: 'Unread',
        update: 'Update',
        view: 'View',
        working: 'Working...',
        yes: 'Yes'
      },
      fields: {
        addedDate: 'Added Date',
        city: 'City',
        coach: 'Team',
        company: 'Company',
        compensationRange: 'Compensation Range',
        createdAt: 'Created at',
        currentCompany: 'Current Company',
        email: 'Email',
        ext: 'Ext',
        fieldNameRequired: '{name} is required',
        fieldRequired: 'This field is required',
        fullName: 'Full Name',
        functionalTitle: 'Functional Title',
        functionalTitles: 'Functional Titles',
        hiringAuthority: 'Hiring Authority',
        industries: 'Industries',
        industry: 'Industry',
        jobFunction: 'Job Function',
        legalName: 'Legal Name',
        location: 'Location',
        otherEmail: 'Other email',
        otherPhone: 'Other phone',
        phone: 'Phone',
        recruiter: 'Recruiter',
        regional: 'Regional Director',
        required: 'Fields marked with * are required',
        requiredAlert: 'Please fill in all required fields',
        requiredWith: '{dependencyLabel} is required when {currentLabel} is selected',
        source: 'Source',
        specialty: 'Specialty',
        state: 'State',
        status: 'Status',
        subStatus: 'Sub-status',
        subspecialty: 'Subspecialty',
        timeRequired: 'Time *',
        title: 'Title',
        type: 'Type',
        zip: 'Zip'
      },
      validations: {
        duplicatePhones:
          'There are duplicate phone numbers. Please delete or update duplicate entries.',
        invalid: 'This field is not valid',
        minRequiredFilters: `Select at least {minRequiredFilters} {noun} to view targeted results`,
        otherEmail: 'Email and Other Email cannot be the same',
        phoneDigits: 'Please enter at least 4 digits',
        title: 'Validation Errors'
      },
      filters: {
        activity: {
          types: {
            title: 'Activity Type',
            placeholder: 'That have all of the selected activities'
          },
          condition: {
            title: 'Match type',
            label: '{entityTitle} who: {value}',
            options: {
              any: 'Have ANY of the selected activities',
              all: 'Have ALL of the selected activities',
              none: 'Have NONE of the selected activities'
            }
          },
          period: {
            title: 'Within Period',
            label: 'Within'
          }
        },
        businessInvolvement: {
          title: 'Involved in',
          jobOrders: 'Job Orders',
          placements: 'Placements',
          sendouts: 'Sendouts',
          feeAgreements: 'Fee Agreements'
        },
        emailValidationPlaceHolder: 'Email Validation',
        excludeOptOut: 'Exclude Opt Outs',
        filterBy: 'Filter by',
        industries: 'Industries',
        invalidEmails: 'Invalid Emails',
        location: 'Location',
        mainCompanyOnly: 'Filter Hiring Authorities using only Main Company Info',
        numberOfContacts: 'Number of Contacts',
        numberOfEmployees: 'Number of Employees',
        openToRelocate: 'Open to Relocate',
        optOutPlaceHolder: 'Email Subscription Status',
        radiusAroundCity: 'Radius around the city in miles',
        revenue: 'Revenue',
        searchSpecificPILCities: 'Include only selected cities (excludes statewide recruiters).',
        searchSpecificPILStates: 'Include only statewide recruiters.',
        showOptOut: 'Show Only Opt Outs',
        team: 'Team',
        validEmails: 'Valid Emails'
      },
      advancedSearch: {
        addFilter: 'Add {title}',
        anytime: 'Anytime',
        noOptionsText: 'Type to search items',
        placeholder: 'Enter an item...',
        preferences: 'Preferences',
        prefernceLabel: `({preference})`,
        editPriority: 'Edit priority',
        priority: 'Priority'
      },
      files: {
        defaultNofileSelectorText: 'No files attached',
        defaultSelectorDescription: 'File not uploaded yet?'
      },
      loading: {
        title: 'Loading content...',
        subtitle: 'Please hang on'
      },
      linkCompany: {
        title: `{capitalizedType} Not Related With Company`,
        noCompany: `There are no company suggestions based on your {type}'s information. Please select or add one.`,
        addCompany: `All {type}s must be related with a company.`,
        suggestions: `Here are some company suggestions based on your {type}'s information. Please select one.`,
        selectCompany: `Select or add the company this {type} is related with:`
      },
      errors: {
        defaultMessage: 'An error has occurred. Please try again.',
        loadFail: 'Something went wrong!',
        unauthorized: 'You do not have permissions to see this information',
        serverError: {
          title: 'Server Error',
          subtitle:
            'Something went wrong while completing your request. Please try again. If the problem persists, contact FortPac Support.'
        },
        profiles: {
          candidate: {
            notFound: {
              title: 'Candidate Not Found',
              subtitle:
                "The Candidate you're looking for is not in the database. Try searching for a different Candidate"
            }
          },
          joborder: {
            notFound: {
              title: 'Job Order Not Found',
              subtitle:
                "The Job Order you're looking for is not in the database. Try searching for a different Job Order"
            }
          },
          hiringAuthority: {
            notFound: {
              title: 'Hiring Authority Not Found',
              subtitle:
                "The Hiring Authority you're looking for is not in the database. Try searching for a different Hiring Authority"
            }
          },
          company: {
            notFound: {
              title: 'Company Not Found',
              subtitle:
                "The Company you're looking for is not in the database. Try searching for a different Company"
            }
          },
          name: {
            notFound: {
              title: 'Contact Not Found',
              subtitle:
                "The Contact you're looking for is not in the database. Try searching for a different Contact"
            }
          }
        }
      },
      emptyState: {
        title: "We couldn't find any information.",
        subtitle:
          "It seems like there are no results for what you're looking for. Please try again",
        cardWrapper: {
          title: 'Loading content.',
          subtitle: 'Please hang on.'
        },
        dropdown: {
          title: 'No more {entity} to show'
        }
      },
      rowActions: {
        actions: {
          add: 'Add',
          applySearch: 'Apply Search',
          call: 'Call',
          download: 'Download',
          edit: 'Edit',
          email: 'Email',
          remove: 'Remove',
          restore: 'Restore',
          sendReminder: 'Send Reminder',
          setAsMain: 'Set as main',
          share: 'Share',
          text: 'Text',
          viewContactInformation: 'View Contact Information',
          viewDetails: 'View Details'
        },
        more: 'More Actions',
        menuItems: {
          remove: {
            title: 'Remove From Search Project'
          }
        }
      },
      searchGlobal: {
        candidate: 'Search by Name, Email, or Position',
        jobOrder: 'Search by Position, or Company',
        company: 'Search by Company Name',
        contact: 'Search by Name, or Email',
        pil: 'Search by industry, Specialty or Subspecialty',
        pilAndPosition: 'Search by industry, Specialty, Subspecialty or position'
      },
      requests: {
        cancelTokenMessage: 'Operation canceled due to new request.'
      },
      dataSheet: {
        footer: {
          buttons: {
            saveDraft: 'Save Progress',
            savingDraft: 'Saving Progress'
          }
        }
      },
      savedSearches: {
        activeSearch: 'Active Search:',
        editSearch: 'Edit Search',
        entityName: 'Saved Searches',
        removeAppliedSearch: 'Remove Applied Search',
        saveAsNewSearch: 'Save as New Search',
        saveSearch: 'Save Search',
        searchActions: 'Search Actions',
        title: 'Saved Searches',
        form: {
          alerts: {
            success: 'Search {action} successfully',
            error: 'Error {action} Search'
          },
          emptyState: {
            title: 'No Saved Searches to Show'
          },
          fields: {
            description: 'Description',
            name: 'Search Name *'
          },
          filtersApplied: 'Filters Applied',
          titles: {
            editSavedSearch: 'Edit Saved Search',
            newSavedSearch: 'New Saved Search'
          }
        },
        emptyState: {
          title: 'No Saved Searches to Show',
          subtitle: "You haven't saved any searches. Once you do, they'll appear here"
        },
        deleteDialog: {
          title: 'Delete Saved Search?',
          message: 'Are you sure you want to delete <b>{name}</b> saved search?'
        },
        shareDrawer: {
          title: 'Share Saved Search',
          alerts: {
            removeAccess: {
              success: 'Access removed successfully',
              error: 'Error removing access'
            },
            share: {
              success: 'Search shared successfully',
              error: 'Error sharing Search'
            },
            userAlreadySelected: {
              title: 'User Already Added',
              body: '{name} already has access to this Search. Select a different user.'
            }
          },
          selectUserPlaceholder: 'Search a User by name',
          usersWithAccess: {
            accessLabel: 'Has access',
            ownerLabel: 'Owner',
            removeAccess: 'Remove access'
          },
          scopeOptions: {
            all: 'All',
            mine: 'Mine',
            sharedWithMe: 'Shared with me',
            sharedToOthers: 'Shared to others'
          },
          removeAccessDialog: {
            title: 'Remove Access?',
            message: 'Are you sure you want to remove access to <b>{name}</b>?'
          }
        }
      }
    },
    layouts: {
      dualPanel: {
        draggableDivider: 'Drag to resize panels',
        toggleLeftPanel: 'Toggle Left Panel'
      }
    },
    navBar: {
      versionBarButton: 'Update',
      artificialIntelligenceButton: 'gpac AI Generator',
      extensionButton: 'Fortpac Extension',
      trainingButton: 'gpac U Training',
      help: 'Help & Information Center',
      versionBar: `You’re using an old version of <b> Fortpac ({version}). </b> Save your work and refresh the page to get the latest version`,
      profile: 'My Profile',
      releaseNotes: `What's New?`,
      logOut: 'Log Out',
      notifications: 'Notifications'
    },
    home: {
      subtitle: 'Take action on your inventory at FortPac now!',
      title: 'Daily Tracker',
      headerActions: {
        filterByNewMembers: 'Filter by Recruiters from 0-3 months'
      },
      shared: {
        dateRange: {
          today: 'Today',
          week: 'Current Week',
          month: 'Current Month',
          yearToDate: 'Year to Date'
        }
      },
      sections: {
        weeklyStats: {
          sendouts: {
            title: 'Sendouts'
          },
          convertedSendovers: {
            title: 'Converted sendovers'
          },
          bulks: {
            title: 'Bulks'
          },
          calls: {
            title: 'Daily Call Time Goal (Minutes)'
          },
          candidatesCard: {
            title: 'New Candidates'
          },
          jobOrdersCard: {
            title: 'New Job Orders'
          }
        },
        dailyStats: {
          bulks: 'Bulks *',
          calls: 'Calls *',
          currentTeamMembers: 'Current Members',
          texts: 'Sent Texts *',
          newCandidates: 'New Candidates',
          newItems: 'New Items',
          newJobOrders: 'New Job Orders',
          newMembers: 'Members from 0-3 months',
          placements: 'Placements',
          sendouts: 'Sendouts',
          sendovers: 'Sendovers',
          sentAgreements: 'Sent Agreements',
          drawBalance: 'Draw Balance',
          drawBalancePeriod: 'Last Processed Pay Period',
          placementsYTD: 'Placements YTD',
          fallOffsYTD: 'Fall Offs YTD'
        },
        dailyStatsOverview: {
          footer: {
            bulks: '* Bulk activity updates every hour approximately. Last updated on {date} at ',
            call: '* Calls and Min may update from 30 min up to 1 hour after the call. Last updated on {date} at ',
            details: `<b>IMPORTANT:</b> If you haven't seen any expected activity update, please refresh FortPac.`,
            externalTools: '* Inmails last updated on {date} at ',
            phonePerformanceRules: 'Learn more about phone performance rules',
            text: '* Texts update every hour. Last updated on {date} at ',
            title:
              '<b>Stats are live</b>, meaning they update on time <b>except in the following cases:</b>'
          }
        },
        drawBalance: {
          details: 'More details on Power BI',
          period: 'Last processed pay period'
        },
        noActivityTotals: {
          candidates: 'Alpha Candidates with No Activity',
          candidatesUnassigned: 'Alpha Candidates Unassigned (from Terms)',
          searchAssignments: 'Search Assignments with No Activity',
          searchAssignmentsUnassigned: 'Search Assignments Unassigned (from Terms)'
        },
        noUpdatedTotals: {
          dailyInterviews: 'Interviews Today',
          sendouts: 'Sendouts Not Updated',
          sendovers: 'Sendovers Not Updated',
          feeAgreements: 'Agreements Pending HA Signature'
        },
        phonePerformanceStats: {
          phonePerformancePercentage: {
            title: 'Phone Performance'
          },
          calls: {
            title: 'Calls'
          },
          time: {
            title: 'Minutes'
          }
        },
        regionalOverview: {
          tabs: {
            todayActivity: `Today's Activity`,
            placementsAndFallOffs: 'Placements & Fall Offs YTD',
            ratios: 'Ratios YTD',
            hireAndTerms: 'Hires and Terms YTD'
          }
        }
      },
      emptyState: {
        team: {
          title: `Check your teams' daily stats`,
          subtitle: 'Select one of your teams to display its current metrics'
        },
        recruiter: {
          title: 'Information not found.',
          subtitle: `We couldn't retrieve any data at the moment. Please refresh the page.
                      If the problem persists, contact FortPac Support.`
        }
      },
      selectRegionAndTeam: 'Filter Stats by Region and/or Team',
      selectTeam: 'Select the team whose stats you want to see'
    },
    creationItems: {
      required: {
        country: 'Country: State *',
        city: 'City *',
        zip: 'Zip Code *'
      },
      noRequired: {
        country: 'Country: State',
        city: 'City',
        zip: 'Zip Code'
      }
    },
    placements: {
      title: 'Placements',
      listing: {
        validations: {
          title: 'Pending Approvals',
          emptyTitle: 'No Validations to Show',
          emptySubtitle: 'All your Placement validations will appear here'
        },
        estimates: {
          title: 'Pending Estimate',
          emptyTitle: 'No Estimates to Show',
          emptySubtitle: 'All estimates will appear here'
        },
        pendingInvoice: {
          title: 'Pending Invoice',
          emptyTitle: 'No Placements to Show',
          emptySubtitle: 'All Placements pending to be invoiced will appear here'
        },
        invoiced: {
          title: 'Invoiced',
          emptyTitle: 'No invoiced Placements to Show',
          emptySubtitle: 'Invoiced Placements will appear here'
        },
        falloff: {
          title: 'Fall Off',
          emptyTitle: 'No fall offs to Show',
          emptySubtitle: 'Fall offs will appear here'
        },
        all: {
          title: 'All',
          emptyTitle: 'No Placements to Show',
          emptySubtitle: 'Try changing your filters'
        }
      },
      referenceRelease: {
        prompt:
          'To create a Placement, make sure you have sent the Reference Release Email to the candidate first',
        helper:
          "To create a Placement, make sure the Candidate's Recruiter has sent the Reference Release Email.",
        secondaryHelper: 'IMPORTANT: Reference Release Emails can now be sent through Fortpac.',
        alreadySent: 'Already sent it outside FortPac?',
        continue: 'Continue creating the Placement',
        send: 'Send Reference Release'
      },
      sendouts: {
        requirement: 'A Sendout needs to be created before creating a Placement',
        create: 'Create a Sendout',
        select: 'Please select a Sendout'
      },
      fields: {
        sendout: 'Select a Sendout',
        feeAgreement: 'Fee Agreement',
        feePercent: 'Fee %',
        requestFeeChangePrompt: 'Request Fee % change',
        agreementType: 'Agreement Type',
        firstYear: 'First Year',
        salary: 'Salary',
        compensation: 'Compensation',
        guaranteeDays: 'Guarantee Days',
        reasonForRequestChange: 'Reason for Fee or Guarantee Days change',
        requestGuaranteeDaysChangePrompt: 'Request Guarantee Period change',
        startDate: 'Start Date',
        fullFeeAmount: 'Full Fee Amount (USD)',
        monthlyAmount: 'Monthly Amount',
        serviceMonths: 'Service Months',
        hiringAuthority: 'Hiring Authority',
        jobOrder: 'Job Order',
        jobOrderSource: 'Job Order Source',
        candidate: 'Candidate',
        candidateDataSource: 'Candidate Source',
        company: 'Company',
        companyPhone: 'Company Phone',
        companyPhoneExtension: 'Company phone extension',
        billToCompany: 'Company',
        billToCompanyHint:
          'Please confirm with your Hiring Authority the Company that will be invoiced',
        billToCompanyPrompt: 'Invoice to a different Company',
        billToCompanyPlaceholder: 'Search by Company name',
        billToCompanyCreatePrompt: 'Create Company',
        falloffReason: 'Fall Off Reason',
        otherFalloffReason: 'Reason',
        noFalloffReasons: 'No Fall Off reasons loaded',
        falloffNotes: 'Notes to Finance Team',
        isJobOrderOpen: 'Is the Job Order still open?',
        isJobOrderOpenHelper:
          "If No is selected, the Job Order type will be updated to Can't help so recruiters stop looking for candidates to fill this position",
        isCandidateOpen: 'Is the Candidate still looking for opportunities?',
        isCandidateOpenHelper:
          "If No is selected, the Candidate type will be updated to Can't help so recruiters stop looking for a position for this candidate",
        requestedChanges: 'Requested changes',
        suggestedChanged: 'Suggested changes',
        notes: 'Notes'
      },
      sections: {
        create: {
          title: 'Create Placement',
          noHireLetterNotice:
            'Once this Placement is approved, a No Hire Letter will be sent to the Hiring Authority regarding the unplaced Candidates.'
        },
        details: {
          title: 'Placement Details'
        },
        split: {
          title: 'Split',
          companySide: 'Company Recruiter',
          candidateSide: 'Candidate Recruiter',
          recruiter: 'Recruiter',
          email: 'Email',
          percent: 'Split Percent',
          amount: 'Split Amount',
          channelPartner: 'Channel Partner'
        },
        company: {
          title: 'Company',
          name: 'Name',
          address: 'Address',
          phoneWithExt: 'Phone - Ext',
          contactName: 'Contact Person',
          contactEmail: 'Contact Email',
          billToCompany: 'Company to Invoice',
          industry: 'Industry'
        },
        joborder: { title: 'Job Order', position: 'Title', source: 'Source' },
        candidate: { title: 'Candidate', name: 'Name', source: 'Source' },
        estimate: {
          title: 'Estimate',
          description: 'Description',
          descriptionTemplate: 'Executive Search by {recruiter} for the Placement of {candidate}',
          terms: 'Payment Terms',
          showCompensation: 'Show Compensation on Invoice',
          message: 'Message Displayed on Estimate',
          memoNotes: 'Message Displayed on Statement',
          glipMessage: 'Message for Glip',
          accountPayableEmail: 'Account Payabale Email',
          paymentDetails: 'Payment Details',
          additionalRecipients: 'Additional Invoice Recipients',
          notes: 'Notes',
          view: 'View Estimate'
        },
        assignmentDataSheet: {
          title: 'Assignment Data Sheet'
        },
        referenceChecks: {
          title: 'Reference Checks',
          recommendation: `It's recommended to 
          fill at least {total} reference checks. Was a reference registered outside FortPac? 
          Upload the file in the attachments section below.`,
          recommendationForLeads:
            "There's only one Reference Check registered; you can request at least {total} Reference Checks to approve the Placement or approve it as it is.",
          label: 'Toggle Reference Check for {name}',
          optionsFor: 'Options for {candidate}',
          requiredValidation: `Please make sure you've selected or uploaded the reference checks`
        },
        attachments: { title: 'Attachments' }
      },
      ctas: {
        sendPlacement: 'Send Placement',
        updatePlacement: 'Update Placement',
        approvePlacement: 'Approve Placement',
        adjustEstimate: 'Yes, adjust Estimate',
        requestChange: 'Request Change',
        requestAChange: 'Request a Change',
        manageInvoices: 'Manage Invoices',
        saveInvoice: 'Save Invoice',
        viewInvoices: 'View Invoices',
        managePayments: 'Manage Payments',
        savePayment: 'Save Payment',
        viewPayments: 'View Payments',
        viewLogs: 'View Logs',
        requestFallOff: 'Request Fall Off',
        completeFallOff: 'Complete Fall Off',
        switchToPlacement: 'Switch to Placement',
        makeAdjustment: 'Make Adjustment',
        changeEstimate: 'Change Estimate',
        updateEstimate: 'Update Estimate',
        uploadEstimate: 'Upload Estimate',
        approveEstimate: 'Approve Estimate',
        viewEstimate: 'View Estimate',
        requestZipFile: 'Request Zip File',
        sendDownloadLink: 'Yes, send me a download link',
        recreateEstimate: 'Recreate Estimate',
        recreateEstimateGoahead: 'Yes, Recreate the Estimate',
        recreateSalesOrder: 'Create New Sales Order',
        recreateSalesOrderGoahead: 'Yes, Create a New Sales Order',
        deletePlacement: 'Delete Placement'
      },
      confirmations: {
        sendPlacement: 'Are you sure you want to send this Placement for approval?',
        updatePlacement: 'Are you sure you want to update this Placement?',
        approvePlacement: 'Are you sure you want to approve this Placement?',
        approveEstimate: 'Are you sure you want to approve the Estimate?',
        adjustPlacement: 'Are you sure you want to adjust this Placement?',
        adjustEstimate:
          'Once you adjust an Estimate, you must wait for a new one to be created. Are you sure you want to edit this Estimate?',
        requestFallOff: 'Are you sure you want to request to mark this placement as Fall Off?',
        completeFallOff: 'Are you sure you want to mark this placement as Fall Off?',
        requestRevertFallOff:
          'Are you sure you want to request Finance to switch back to Placement?',
        revertFallOff: 'Switching back to placement would perform the following changes:',
        requestZipFile: 'Do you want to create a zip file with all of attachments?',
        recreateEstimate: 'Are you sure you want the Estimate to be recreated?',
        recreateEstimateHelper: `Finance and Recruiter's Approvals will be needed again.`,
        recreateSalesOrder: 'Are you sure you want to create a new Sales Order?',
        recreateSalesOrderHelper:
          'Use this option sparingly because a completely new Sales Order in NetSuite will be created and FortPac Placement ID will change.',
        deletePlacement: 'Are you sure you want to delete this Placement?',
        deletePlacementHelper:
          'You are about to permanently delete this placement and its related information. You will not be able to recover it. <strong>This operation cannot be undone.</strong>'
      },
      messages: {
        title: 'Placement Info',
        creation: 'Are you sure you want to send this Placement for approval?',
        placementUpdated: 'Placement Updated',
        placementUpdatedSubtitle: 'Waiting for approval',
        placementApproved: 'Placement Approved',
        placementApprovedSubtitle: 'The Placement was approved successfully',
        placementAdjusted: 'Placement Adjusted',
        placementAdjustedSubtitle: 'The adjustment was saved successfully',
        placementDeleted: 'Placement Deleted',
        placementDeletedSubtitle: 'The Placement was deleted sucessfully',
        estimateUpdated: 'Estimate Updated',
        estimateUpdatedSubtitle: 'The Estimate will be processed again',
        estimateRecreated: 'Estimate Recreation Requested',
        estimateRecreatedSubtitle: 'The Estimate will be recreated in about 5 minutes',
        salesOrderRecreated: 'Sales Order Recreation Requested',
        salesOrderRecreatedSubtitle: 'The Sales Order will be recreated in about 5 minutes',
        notFound: 'The placement info was not found'
      },
      payments: {
        history: 'Payment history',
        empty: 'No Payments yet'
      }
    },
    feeAgreements: {
      plural: 'Fee Agreements',
      singular: 'Fee Agreement',
      create: 'Create Fee Agreement',
      sections: {
        validations: {
          title: 'Validations',
          empty: 'No validations to Show',
          emptySubtitle: 'All your Fee Agreement validations will appear here'
        },
        sent: {
          title: 'Sent Fee Agreements',
          empty: 'No Fee Agreements to Show',
          emptySubtitle: 'All Fee Agreements sent to sign will appear here'
        },
        signed: {
          title: 'Signed Fee Agreements',
          empty: 'No Signed Fee Agreements to Show',
          emptySubtitle: 'Signed Fee Agreements will appear here'
        }
      },
      fields: {
        feeNo: 'Fee #',
        fee: 'Fee',
        flatAmount: 'Flat Fee Amount',
        guaranteeDays: 'Guarantee Days',
        sentAt: 'Sent at',
        haSignedAt: 'HA Signed at',
        gpacSignedAt: 'gpac Signed at',
        validatedBy: 'Validated by',
        type: 'Type',
        notes: 'Notes from Recruiter',
        ccs: 'CC Emails',
        numberOfPayments: 'Number of Payments',
        payment: 'Payment'
      },
      messages: {
        reminderOk: 'Reminder Sent Successfully',
        approvedOk: 'Fee Agreement Approved Successfully',
        createdOk: 'Fee Agreement Created Successfully',
        submittedOk: 'Fee Agreement Submitted Successfully',
        declinedOk: 'Fee Agreement Declined Successfully',
        savedOk: 'Fee Agreement Saved Successfully',
        voidedOk: 'Fee Agreement Voided Successfully',
        canceledOk: 'Fee Agreement Request Canceled Successfully',
        emailsOk: 'Emails Updated Successfully',
        swithServiceOk: 'Signing Service Changed Successfully',
        reactivatedOk: 'Fee Agreement Reactivated Successfully',
        sentOk: 'Fee Agreement Sent Successfully',
        templateOk: 'Template Created Successfully',
        templateCanceled: 'Signature Request Canceled',
        paymentTermsNotFound: 'Payment Combinations Not Found'
      },
      creation: {
        notesWarning: 'Do not use for verbiage or adjustments instructions',
        creationTitle: 'Send Fee Agreement to Sign',
        requestApproval: 'Request approval',
        sendToSign: 'Send to sign',
        sendToOps: 'Send to Ops',
        confirmApproval: 'Are you sure you want to send this Fee Agreement for approval?',
        confirmSendToSign:
          'Are you sure you want to send a signature request to {hiringAuthority}?',
        confirmOpsApproval: 'Are you sure you want to send this Fee Agreement for Ops validation?',
        confirmCreation: 'Are you sure you want to create this agreement?',
        confirmCreationWhenVerbiage:
          'Are you sure you want to create this agreement? Remember to create the template in the Fee Agreements section',
        viewTemplate: 'View contract template',
        chooseProcess: 'Creation state',
        blankState:
          'To create a Fee Agreement signature request, make sure there is a Job Order and the company is ready to sign',
        noHiringAuthorities:
          'Please assign a Hiring Authority to this Company before creating a Fee Agreement',
        blankCTA: 'Create Job Order',
        onBehalf:
          'Please enter a name ONLY if you are sending the agreement on behalf of a recruiter:',
        onBehalfExternal: 'Please select the recruiter who sent this agreement:',
        selectRecruiter: 'Select recruiter',
        feePercent: 'Fee %',
        flatAmount: 'Flat Fee Amount (USD)',
        guaranteeDays: 'Days Under Guarantee',
        verbiageChanges: 'Verbiage Change(s)',
        verbiage: 'Verbiage ',
        requestFeeChange: 'Request Fee Agreement % change',
        requestPaymentTerm: 'Request different Payment Terms',

        requestGuaranteeChange: 'Request Guarantee Period change',
        requestVerbiageChange: 'Request Verbiage changes',
        verbiageValidation: 'Please specify the verbiage changes',
        hiringAuthorityHelper:
          'Are you speaking directly to the decision maker that has the final approval?',
        emailsHelper: `You can add copies to other people involved in the review process - you and your Regional Director get an automatic copy -`,
        emailsPlaceholder: 'Add CCs -up to {0} emails-',
        relatedJobOrders: 'Related Job Orders',
        relatedJobOrdersWithFA: 'With Fee Agreements',
        relatedJobOrdersWithoutFA: 'Without Fee Agreements',
        relatedJobOrdersHelper: 'Make sure your Job Order(s) are linked to this agreement',
        verbiageWhenOnbehalf:
          'After saving this agreement, please go to the Fee Agreements section to create the new template',
        notesFromRecruiter: 'Notes',
        notes: `Please don't use this notes to request verbiage changes. Use the specific section above instead`,
        notesValidation: 'Please specify why you are requesting these changes',
        externalIntro:
          "It's optional to fill out the information below. If you are missing some info, you can request the Ops Team to complete the agreement and upload the file for you.",
        notesToOps: 'Notes to Ops Team',
        signingDate: 'Signing date',
        sentDate: 'Sent date',
        wrongDates: 'Sign date must be after sent date',
        fileExplorerSection: 'Company Files',
        legalNameWarning: 'The legal name is required to prevent possible litigations',
        invalidDecimals: 'Please use only one decimal',
        invalidPercentage: 'Invalid percentage value'
      },
      validation: {
        modifyVerbiage: 'Modify the Following Verbiage Change',
        declinationReason: 'Reasons of declination:',
        modifyDeclined: 'Modify the declined fields',
        opsDeclined: 'Ops Team has explained why the Fee Agreement request was Declined.',
        confirmInformation: 'Confirm information:'
      },
      details: {
        title: 'Fee Agreement Details',
        viewPdf: 'View PDF',
        viewContract: 'View contract template',
        sign: 'Sign',
        void: 'Void',
        confirmVoid: 'Are you sure you want to void this Fee Agreement?',
        validate: 'Validate',
        approve: 'Approve',
        confirmApprove: 'Are you sure you want to approve this Fee Agreement?',
        declineChange: 'Decline changes',
        decline: 'Decline',
        sendReminder: 'Send reminder',
        cancelRequest: 'Cancel request',
        confirmCancel: 'Are you sure you want to cancel this Fee Agreement request?',
        revalidate: 'Re-validate',
        preview: 'Preview & Send',
        copyLink: 'Copy Signing Link',
        updateEmails: 'Update emails',
        changeSigner: "Change signer's email",
        reactivateTitle: 'Reactivate expired agreement',
        reactivateButton: 'Reactivate',
        confirmReactivate: 'Are you sure you want to reactivate this expired agreement?',
        switchServiceTitle: 'Switch to backup signing service',
        switchServiceButton: 'Switch to backup service',
        confirmSwitch:
          'Are you sure you want to switch to the backup signing service for this agreement? Before proceeding, please make sure that:',
        createTemplate: 'Create template',
        requestedChanges: 'Requested changes',
        poweredBy: 'Signature request using ',
        eventHistory: 'Event History',
        lastActivity: 'Last activity',
        titleConfirmSendReminder: 'Confirm Sending Reminder',
        signatureRequestReminded: 'Signature request reminded',
        confirmationSendReminder:
          'Once the reminder is sent, a new link will be created and the previous one will become disabled. Are you sure you want to send a reminder?',
        noReminder: 'No reminder has been sent'
      },
      dashboard: {
        emptyState: {
          title: 'We could not find any information.',
          subtitle: 'It seems like there are no results for what you are looking for.'
        }
      }
    },
    sendoutsV2: {
      title: 'Sendouts',
      alerts: {
        noSignedCompany: {
          title: 'Company not signed yet',
          description: 'To create a Sendout, this company must be signed',
          cancel: 'Cancel',
          viewCompany: 'View Company',
          signCompany: 'Sign Company'
        },
        confirmationDialogs: {
          emailConfirmation: {
            title: 'Verify Information',
            message: 'Make sure the information below is correct.'
          },
          noAttachments: {
            title: 'Send Without Attachments?',
            message:
              'There are no Candidate files attached to this Sendout. Are you sure you want to send it?'
          },
          conversionWithoutMail: {
            title: 'Confirm Details',
            message: 'This info will be sent to everyone invlolved.',
            notificationSubtitleText: 'Sending notification to:',
            notificationText:
              "Operations, Sendouts Team, Recruiters Teams, Recruiters in the same inventory's industry and Recruiters Involved."
          },
          closeForm: {
            title: 'Closing {documentType}',
            message:
              'To avoid losing your work, please save your {documentType} before exiting. Are you sure you want to close the {documentType} form?',
            actions: {
              discardAndExit: 'Discard & Exit',
              cancel: 'Back to {documentType}'
            }
          }
        },
        submitMessages: {
          success: {
            title: '{processType} {action} Successfully'
          },
          error: {
            title: 'Error {action} {processType}'
          },
          actions: {
            created: 'Created',
            creating: 'Creating',
            scheduled: 'Scheduled',
            scheduling: 'Scheduling',
            updated: 'Updated',
            updating: 'Updating'
          },
          unexpectedStatus: 'Unexpected response status: {status}'
        }
      },
      processTypes: {
        interview: 'Interview'
      },
      form: {
        sections: {
          accountableSelector: {
            title: 'Accountability',
            subtitle: 'Who is managing this process?'
          },
          attachments: {
            title: 'Attachments',
            subtitle:
              'Candidate files are preloaded. Make sure all files are uploaded to the Candidate’s profile before creating a Sendout.',
            categories: {
              resume: 'Resume',
              portfolio: 'Portfolio',
              otherFiles: 'Other Files'
            },
            errors: {
              maxSizeExceeded:
                'The selected files exceed the size limit to send ({total} / {max}). Please deselect some files.'
            }
          },
          interviewDetails: {
            title: 'Interview Details',
            labels: {
              interviewLink: 'Interview Link',
              interviewAddress: 'Interview Address',
              remoteVideo: 'Remote / Video',
              faceToFace: 'In Person',
              date: 'Date *',
              timeFrame: 'Time Frame *',
              hour: 'Select Hour *',
              timezone: 'Select Timezone +',
              reminders: "Don't send reminders",
              fixedHour: 'Fixed Hour',
              timeRange: 'Time Range'
            },
            errors: {
              invalidInterviewLink: 'The link must be valid and start with http:// or https://'
            }
          },
          otherInterviewer: {
            title: 'Other Interviewer',
            labels: {
              fullName: 'Full Name',
              email: 'Email',
              carbonCopy: 'CC'
            },
            errors: {
              invalidEmail: 'Email must be valid'
            }
          },
          candidateDetails: {
            title: 'Candidate Details',
            subtitle: 'Select the Inventory involved.',
            labels: {
              candidateRecruiter: 'Candidate Recruiter *',
              estimatedFeeAmount: 'Estimated Fee Amount *',
              selectCandidate: 'Search Candidate by Name or Email *'
            },
            alerts: {
              duplicateCandidate:
                "There's already either a Sendover or a Sendout registered with the same Candidate. To avoid duplicates, convert the Sendover or add new interviews to the Sendout."
            }
          },
          sendoverReasons: {
            errors: {
              reasons: 'Select at least one option',
              catalogUnavailable: 'Sendover reasons are unavailable. Please try again.'
            },
            labels: {
              comments: 'Other reasons or comments'
            },
            title: 'Sendover Reasons',
            subtitle: "Reason why sendout wasn't arranged at time of presentation?"
          },
          emailDetails: {
            title: 'Email Details',
            hiringAuthorityAutomaticReminder: {
              description:
                "If there's no communication with the Hiring Authority within 2 business days of sending the resume, FortPac will send an automatic follow up email to the Hiring Authority.",
              topPerformerDescription:
                "Enable automatic reminders if you want FortPac to send a follow-up email after 2 business days if there's no communication with the Hiring Authority",
              label: 'Enable Automatic Reminder',
              learnMore: 'Learn More'
            }
          },
          declinationReasons: {
            subtitle: 'Select at least one reason',
            commentsLabel: 'Comments',
            reasonsValidationMessage: 'Select at least one reason',
            catalogUnavailable: 'Reasons are unavailable. Please try again.'
          }
        },
        emptyPlaceholderText: 'You are not allowed to create {documentType} for this Job Order',
        initialFetchingError:
          'Failed to load necessary information to create this {documentType}. Please try again.'
      },
      drawers: {
        duplicates: {
          title: `Existing Sendovers or Sendouts`,
          alert: `Here's the list of Sendovers or Sendouts registered for <b>{jobOrderTitle}</b> with <b>{candidateName}</b>`
        },
        sendover: {
          title: 'Create Sendover',
          details: {
            error:
              'Something went wrong fetching the details of this Sendover. Please Try Again. If the problem persists, contact FortPac Support.'
          }
        },
        sendoutDetails: {
          title: 'Sendout Details',
          actions: {
            closingCall: 'Closing Call',
            editDetails: 'Edit Sendout Details',
            startPlacement: 'Start Placement'
          }
        },
        sendoutDetailsEdit: {
          title: 'Edit Sendout Details'
        },
        sendoverDetails: {
          title: 'Sendover Details',
          actions: {
            editDetails: 'Edit Sendover Details'
          }
        },
        sendoverDetailsEdit: {
          title: 'Edit Sendover Details'
        },
        sendoutInterviewDetails: {
          title: 'Interview Details',
          error: 'Something went wrong loading the interview details. Please try again.',
          empty: 'No interview details are available.',
          emptyCall: 'No {callName} has been recorded for this interview yet.',
          calls: {
            hiringAuthorityCall: 'Hiring Authority Call',
            candidateCall: 'Candidate Call',
            hiringAuthorityInsights: 'HA Call Insights',
            candidateInsights: 'Candidate Call Insights'
          },
          details: {
            scheduledTime: 'Scheduled Date/Time',
            status: 'Status',
            interviewType: 'Interview Type',
            interviewLink: 'Interview Link',
            interviewAddress: 'Interview Address',
            otherInterviewers: 'Other Interviewers',
            reminders: 'Reminders'
          },
          tabs: {
            interviewDetails: { title: 'Interview Details' },
            preparationCall: { title: 'Preparation Call' },
            debriefingCall: { title: 'Debriefing Call' }
          }
        },
        interviewDebrief: {
          employer: { title: 'Employer Debrief' },
          candidate: { title: 'Candidate Debrief' }
        },
        createSendoutInterview: {
          title: 'Schedule Interview'
        },
        declinationReasons: {
          title: {
            declination: 'Offer Declined Reasons',
            noOffer: 'No Offer Reasons',
            otherReason: 'Other Reason',
            sendoverReasons: 'Sendover Reasons'
          }
        },
        tabs: {
          attachments: {
            title: 'Attachments',
            sendoutFiles: 'Sendout Files',
            noAttachments: 'No attachments in this category',
            offerLetter: {
              title: 'Offer Letter',
              description:
                'These files belong to the Sendout and are not sent to the Hiring Authority. Will be auto attached when creating the placement.'
            }
          },
          interviews: {
            title: 'Interviews'
          },
          emails: {
            title: 'Emails'
          },
          activityLogs: {
            title: 'Activity Logs',
            user: 'User',
            emptyState: {
              title: 'Nothing done yet!',
              subtitle: 'Once an Activity is added, it will be shown here'
            },
            searchEmptyState: {
              title: 'No activity logs found',
              subtitle: 'Try adjusting your search'
            },
            pageEmptyState: {
              title: 'No activity logs on this page',
              subtitle: 'Loading the first page'
            }
          },
          notes: {
            title: 'Notes',
            add: 'Add Note',
            placeholder: 'Note Description',
            emptyState: {
              title: 'Nothing done yet!',
              subtitle: 'Add a note by clicking on the + button'
            },
            alerts: {
              title: 'Sendout Notes',
              created: 'Note created successfully',
              updated: 'Note updated successfully'
            }
          },
          status: {
            loading: 'Loading content...',
            error: 'Something went wrong'
          }
        }
      },
      hotsheet: {
        filters: {
          declinationReasons: {
            title: 'Reasons',
            displayLabel: 'Declination Reason'
          }
        }
      }
    },
    sendouts: {
      title: 'Sendouts',
      sendoutType: `Select if it's a Sendout or a Sendover`,
      tab: {
        actions: {
          createSendout: 'Create Sendout',
          createSendover: 'Create Sendover'
        }
      },
      interviews: {
        timeRequired: {
          type: 'isBeforeActualDateTime',
          message: `Sendouts can't be scheduled in the past.`
        },
        scheduleCalls: {
          validations: {
            incompleteCall: 'Select a date and time for the interview',
            atLeastOneCall: 'Select at least one interview date and time'
          }
        },
        interviewDetails: {
          actions: {
            cancel: 'Cancel Editing',
            edit: 'Edit Interview'
          }
        }
      },
      form: {
        buttons: {
          switch: 'Switch to Sendout'
        },
        labels: {
          accountableRecruiter: 'Accountable Recruiter',
          date: 'Date *',
          timeFrame: 'Time Frame *',
          hour: 'Select Hour *',
          fromHour: 'From Hour *',
          toHour: 'To Hour *',
          timezone: 'Select Timezone *',
          reminders: "Don't send reminders",
          status: 'Status *',
          estimatedFee: 'Estimated Fee Amount *',
          hiringAuthority: 'Hiring Authority *',
          interviewLink: 'Interview Link',
          candidateRecruiter: 'Candidate Recruiter *'
        },
        errors: {
          fixedHourPastTime: 'Select a future time when scheduling an interview for today.',
          timeRangePastStartTime:
            'Select a future start time when scheduling an interview for today.',
          invalidInterviewTime: 'Select a time that exists in the interview timezone.',
          invalidTimeRange: 'Time Range is not valid'
        }
      },
      attachments: {
        fileSelectorDefault: 'No files attached to this Candidate',
        description: `Candidate files are preloaded. Make sure all files are uploaded to the Candidate's profile before creating a Sendout.`,
        noFilesAdded: 'No attachments added to send',
        noFilesView: 'No attachments added to view',
        noCategories: 'There are no categories to show',
        noFilesSend:
          'These files belong to the Sendout and are not sent to the Hiring Authority. To upload the files correctly, click the update button.',
        removeFiles: `If you don't want to send any Candidate attachments, remove them before sending the Sendout`
      },
      errors: {
        loading:
          'Failed to load this Sendout. Please refresh the page. If the problem persists, contact Fortpac Support.'
      },
      details: {
        navigationPlacementConfirm: `You'll be redirected to the Packet Cover Sheet creation form. Do you want to start the Placement for this deal now?`,
        sendoutOnBehalf: `Select the Recruiter you're sending on behalf of`
      },
      hiringAuthority:
        'Changing the Hiring Authority for this Sendout will only be for documentation purposes, but nothing can be sent to them for now.',
      dontSendReminder:
        'By selecting this option, no reminders will be sent to the Candidate nor the Hiring Authority before the interview.',
      nextInterviewDiferent: 'If the next interviewer is different than hiring authority',
      dashboard: {
        emptyState: {
          title: 'We could not find any information.',
          subtitle:
            'It seems like there are no results for what you are looking for. Please try again'
        }
      },
      switchingToSendEmailCopies: {
        isWithoutMailCopies: {
          isWithoutMailTitleCopy:
            'This Sendout {auxiliary} send an email to the Hiring Authority, but you can',
          sendEmailCopy: {
            button: 'Switch and send mail.',
            hint: `It's recommended not to send an email when registering Sendouts created outside FortPac.`
          },
          notSendEmailCopy: {
            button: 'Switch without mail.',
            hint: ` It's recommended to send emails when registering new Sendouts.`
          }
        }
      },
      noEmailSendCopies: {
        title: 'Email not sent to Hiring Authority.',
        button: 'Click here to send it',
        hint: 'Select this option if you want to register a Sendout that was created outside FortPac.'
      },
      duplicates: {
        alert: {
          title: `There's already either a Sendover or a Sendout registered with the same Candidate. To avoid duplicates, convert the Sendover or add new interviews to the Sendout. `
        },
        drawer: {
          title: `Existing Sendovers or Sendouts`,
          subtitle: `Here's the list of Sendovers or Sendouts registered for <b>{jobOrderTitle}</b> with <b>{candidateName}</b>`
        },
        fetch: {
          title: 'Sendovers or Sendouts Already Registered',
          message: 'To avoid duplicates, please look for it to edit its information.'
        }
      },
      tagsAndSignatureCopy: 'Your signature will be included automatically when sending the email.',
      sendEmailToHiringAuthorityCopy: `By clicking on this option, the email won't be sent to anyone, but you'll receive a notification in Fortpac with the Sendout details.`,
      emailTemplateCopy: `You can edit the information on the following box; below it, there's a preview of the email that will be sent.`,
      showConfirmWithEmailCopies: {
        severity: 'warning',
        title: 'Verify Information',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Close',
        message: 'Make sure the information below is correct.'
      },
      showConfirmWithoutEmailCopies: {
        severity: 'warning',
        title: 'Confirm Details',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Close',
        message: 'This info will be sent to everyone involved.'
      },
      showConfirmEditCopies: {
        severity: 'info',
        title: 'Please confirm',
        message: 'Are you sure you want to mark this Sendout as a Placement?'
      },
      showConfirmNoFilesWarningSendoutCopies: {
        severity: 'warning',
        title: 'Send Without Attachments',
        confirmButtonText: 'Send',
        message: `There are no Candidate files attached to this Sendout. Are you sure you want to send it?`
      },
      showConfirmNoFilesWarningSendoverCopies: {
        severity: 'warning',
        title: 'Send Without Attachments',
        confirmButtonText: 'Send',
        message: `There are no Candidate files attached to this Sendover. Are you sure you want to send it?`
      },
      showConfirmDeleteCopies: {
        severity: 'warning',
        title: 'Please confirm',
        message: 'Are you sure you want to delete this Sendout?'
      },
      createdAlert: {
        title: `{type} Created Successfully`
      },
      updatedAlert: {
        title: `{type} Updated Successfully`
      },
      deletedAlert: {
        title: `{type} Deleted Successfully`
      },
      canNotDeletedAlert: {
        title: `{type} can't be deleted`
      },
      showConfirmResendEmail: {
        title: `Resend Email`,
        message: `All attachments included in the {type} will be sent to the Hiring Authority. Are you sure you want to resend this {type}?`,
        success: `{type} was Resent Successfully`
      },
      hiringAuthorityAutomaticReminder: {
        description:
          "If there's no communication with the Hiring Authority within 2 business days of sending the resume, FortPac will send an automatic follow up email to the Hiring Authority.",
        topPerformerDescription:
          "Enable automatic reminders if you want FortPac to send a follow-up email after 2 business days if there's no communication with the Hiring Authority",
        label: 'Enable Automatic Reminder',
        learnMore: 'Learn More'
      }
    },
    bulkEmails: {
      title: 'Bulk Email',
      content: {
        list: {
          aiLabel: 'Powered by AI',
          chips: {
            sequence: 'Sequence'
          }
        },
        drafts: {
          title: 'Bulk Draft Preview',
          menuItemsTitles: {
            edit: 'Edit',
            delete: 'Delete'
          }
        },
        schedule: {
          title: 'Scheduled Bulk Preview',
          menuItemsTitles: {
            edit: 'Edit',
            sendNow: 'Send Now',
            reschedule: 'Reschedule',
            delete: 'Delete'
          }
        },
        sent: {
          searchBarPlaceholder: 'Search by Subject or Search Project',
          bulkStatsButton: 'Bulk Stats',
          title: 'Bulk Preview',
          sequences: {
            title: 'Sequence Preview',
            buttons: {
              cancelSequence: 'Cancel Sequence',
              addSteps: 'Add Steps'
            }
          }
        },
        template: {
          searchBarPlaceholder: 'Search by Name',
          title: 'Template Preview',
          menuItemsTitles: {
            edit: 'Edit',
            archive: 'Archive',
            restore: 'Restore'
          },
          dialogs: {
            discard: {
              title: 'Discard Template',
              message:
                "You'll lose your current progress. Are you sure you want to discard this template?"
            }
          },
          drawer: {
            edition: 'Edit Template',
            new: 'New Template'
          }
        }
      },
      dialogs: {
        sequences: {
          cancelOwnSequence: {
            title: 'Cancel Sequence',
            message:
              "Canceling this sequence will stop all remaining emails from being sent.<br>This action can't be undone. Are you sure you want to cancel this sequence?",
            confirmButtonText: 'Cancel Sequence',
            cancelButtonText: 'Keep Sequence'
          },
          cancelStep: {
            mainContent: {
              title: 'Cancel Step',
              cancelButtonText: 'Keep',
              confirmButtonText: 'Cancel Step'
            },
            body: {
              message:
                "You are about to permanently cancel the {ordinalNumber} Step. The remaining steps will keep their current schedules. To change or cancel another step's schedule, edit that step individually.",
              dates: {
                mainCopy: '{ordinalNumber} Step: {sendingDate}{canceled}',
                fillers: {
                  canceled: ' (Canceled)'
                }
              },
              question: 'Are you sure you want to cancel this step?'
            }
          },
          changeBulkType: {
            title: 'Change Bulk Type',
            message:
              "You're currently composing a bulk sequence. Changing the bulk type will reset all content and settings from the initial bulk and its sequence attempts. Are you sure you want to change the bulk type?",
            confirmButtonText: 'Change & Reset',
            cancelButtonText: 'Cancel'
          }
        },
        cancel: {
          copies: {
            title: 'Discard {titleType} Changes',
            message: `You'll lose your current progress. Are you sure you want to discard this {messageType}?`,
            discardButtonText: 'Discard',
            keepEditingButtonText: 'Keep Editing',
            saveButton: 'Save {save}'
          },
          variants: {
            default: {
              titleType: 'Bulk',
              messageType: 'bulk',
              save: 'as Draft'
            },
            sequenceAttempt: {
              titleType: 'Attempt',
              messageType: 'attempt',
              save: 'Changes'
            },
            drafts: {
              titleType: 'Draft',
              messageType: 'draft',
              save: 'Changes'
            },
            schedule: {
              titleType: 'Scheduled Bulk',
              messageType: 'bulk',
              save: 'Changes'
            }
          }
        },
        restrictions: {
          titles: {
            send: 'Sending too many emails too quickly',
            schedule: 'Scheduling too many bulks in a short time',
            noQuotaAvailable: 'Daily Quota Reached',
            quotaNearlyReached: 'Daily Quota Nearly Reached',
            defaultRestriction: 'Bulk Unable to Create'
          },
          actions: {
            saveAsDraft: 'Save as Draft',
            close: 'Close',
            cancel: 'Cancel',
            schedule: 'Schedule Bulk',
            setDifferentTime: 'Set a Different Time',
            continueAnyway: 'Continue Anyway'
          },
          bodyMessages: {
            noQuotaAvailable:
              'You have no available recipient quota for today. You can schedule this bulk for tomorrow, when your daily quota resets{saveAsDraft}. If other bulks use your available quota before its scheduled send time, this bulk will not be sent.',
            quotaNearlyReached:
              'You have {remainingQuota} recipient(s) available in your bulk quota for today, but the Search Project you selected has {searchProjectSize} recipient(s). If you continue, the bulk will only be sent to {remainingQuota} recipient(s). You can view who received it in Bulk Stats. You can also schedule the bulk to send later{saveAsDraft}.',
            // Space here is not accidental, it's needed!
            saveAsDraft: ' or save it as a draft'
          }
        },
        sendBulk: {
          title: `Send Bulk Confirmation`,
          message: `Please confirm all the Bulk's details before sending`,
          confirmButtonText: 'Send',
          cancelButtonText: 'Cancel'
        },
        sendBulkSequence: {
          title: 'Start Sequence',
          message:
            "Once the first bulk in this sequence is sent, it can't be canceled or recalled. If you decide to stop the sequence later, only the remaining unsent bulks will be canceled.<br>Are you sure you want to start this sequence?",
          confirmButtonText: 'Start Sequence',
          cancelButtonText: 'Cancel'
        },
        noQuotaSequence: {
          title: 'Daily Quota Reached',
          message:
            'Bulks sent or scheduled to send today have used your {initialQuota}-recipient daily quota. You can send this sequence tomorrow.',
          confirmButtonText: 'Close'
        },
        draftDelete: {
          cancelButtonText: 'Keep',
          confirmButtonText: 'Delete',
          message: 'This action is permanent. Are you sure you want to delete this draft?',
          title: 'Delete Draft'
        },
        scheduleDelete: {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Keep',
          message: 'This bulk will no longer be sent. Are you sure you want to delete this bulk?',
          title: 'Delete Bulk'
        },
        scheduleSendNow: {
          title: 'Send Scheduled Bulk',
          message: `Are you sure you want to send this bulk now?`,
          confirmButtonText: 'Send',
          cancelButtonText: 'Cancel'
        },
        scheduleForm: {
          timezoneInfo:
            'The bulk will be scheduled in the timezone of your location<br>(Current Timezone: {currentTimeZone})',
          create: {
            body: 'Pick date & time to schedule',
            copies: {
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Schedule',
              title: 'Schedule Bulk'
            }
          },
          edit: {
            body: 'Pick date & time to reschedule',
            copies: {
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Reschedule',
              title: 'Reschedule Bulk'
            }
          },
          validations: {
            required: 'Schedule {moment} is required',
            refs: {
              date: 'Date',
              time: 'Time'
            }
          }
        },
        archiveTemplates: {
          title: 'Archive {entity}',
          message:
            'The {entity} will be available for {retentionDays} days in the Archived Folder. If not restored before those days, it will be permanently deleted. Are you sure you want to archive this {entity}?',
          confirmButtonText: 'Archive {entity}',
          cancelButtonText: 'Cancel'
        }
      },
      emptyStates: {
        emailItems: {
          searchProjectName: '(No Search Project Selected)',
          subject: '(No Subject)'
        },
        sent: {
          list: {
            title: 'No Bulks Sent',
            subtitle: 'All your sent bulks will appear here.'
          },
          preview: {
            title: 'No Bulk Selected',
            subtitle: 'Select a bulk to preview.'
          }
        },
        drafts: {
          list: {
            title: 'No Drafts to Show',
            subtitle: 'All your bulk drafts will appear here.'
          },
          preview: {
            title: 'No Draft Selected',
            subtitle: 'Select a draft to preview.'
          }
        },
        template: {
          list: {
            title: 'No Templates to Show',
            subtitle: 'All your bulk Templates will appear here.'
          },
          preview: {
            title: 'No Template Selected',
            subtitle: 'Select a template to preview.'
          }
        },
        schedule: {
          list: {
            title: 'No Scheduled Bulks to Show',
            subtitle: 'All your scheduled bulks will appear here.'
          },
          preview: {
            title: 'No Scheduled Bulk Selected',
            subtitle: 'Select a scheduled bulk to preview.'
          }
        }
      },
      errors: {
        addSequenceStep: { title: 'Error while adding sequence steps' },
        bulkTemplateById: {
          title: "Couldn't Load Template Content"
        },
        cancelSequence: {
          title: 'Error while canceling sequence'
        },
        cancelSequenceStep: {
          title: 'Error while canceling sequence step'
        },
        createOptOut: {
          title: 'Error While Opting Out Email'
        },
        deleteBulkEmailDraft: {
          title: "Couldn't delete draft"
        },
        deleteScheduledBulkEmail: {
          title: 'Unexpected error while trying to discard scheduled bulk'
        },
        deleteTemporaryAttachments: {
          title: 'Error while deleting file'
        },
        editSequenceStep: { title: 'Error while editing sequence step' },
        gettingBulkById: 'Error on email preview',
        gettingDrafts: 'Error while getting drafts',
        gettingEmailSignature: 'Error while getting email signature',
        gettingSchedules: 'Error while getting schedule emails',
        gettingSentEmails: 'Error while getting sent emails',
        gettingSequencesTriggerDays: 'Error while getting Step delay days',
        loadBulkPreview: {
          title: 'Error setting preview data'
        },
        optOutList: {
          title: 'Error getting Opt Out List'
        },
        optOutReasons: {
          title: 'Error While Loading Reasons'
        },
        removeAttachments: {
          noType: {
            title: 'File Missing Type',
            body: `The file you're trying to remove doesn't have type. Allowed types (temporal, template)`
          }
        },
        removeFromOptOut: {
          title: 'Error While Removing From Opt Out'
        },
        sendBulkDraft: {
          title: 'Bulk Email Draft Was Not Saved'
        },
        sendBulkEmail: {
          title: 'Bulk Email Was Not Sent'
        },
        sendBulkSequence: {
          title: 'Bulk Sequence Was Not Created'
        },
        updateBulkEmailDraft: {
          title: "Couldn't update draft"
        },
        updateScheduleDate: {
          title: `Unexpected Error while updating scheduled bulk`
        },
        uploadTemporaryAttachments: {
          title: "Couldn't upload images to temp folder"
        }
      },
      forms: {
        bulkDrawer: {
          titles: {
            bulkEmail: 'Bulk Email',
            sequencePreview: 'Bulk Sequence Preview'
          },
          buttons: {
            cancel: 'Cancel',
            goBack: 'Go Back',
            preview: 'Preview',
            previewSequences: 'Continue to Preview',
            save: 'Save Changes',
            schedule: {
              title: '{preposition}chedule Bulk',
              prepositions: {
                schedule: 'S',
                reschedule: 'Res'
              }
            },
            sendBulk: 'Send Bulk',
            sendSequence: 'Send Bulk Sequence'
          }
        },
        titles: {
          optOut: 'Opt-out email registration'
        },
        sequences: {
          alerts: {
            recipientsToReach:
              "Automatic sendings will reach to recipients that didn't reply to the previous step",
            quota:
              'This step will consume available bulk credits from the day it triggers, you will see more details in the bulk stats'
          },
          buttons: {
            addStep: 'Add {attempt} Step',
            removeStep: 'Remove Step'
          },
          addSteps: {
            title: 'Add Sequence Steps',
            previewTitle: 'Steps Preview',
            buttonsDefinitions: {
              cancel: 'Cancel',
              preview: 'Continue to Preview',
              back: 'Go Back',
              save: 'Save'
            }
          },
          editStep: {
            title: 'Edit Sequence Step',
            previewTitle: 'Step Preview',
            saveChangesDialog: {
              title: 'Edit Sequence Step',
              message:
                'Changes made will only apply to the step {currentStep} in this sequence.<br>Are you sure you want to edit this Step?',
              confirmButtonText: 'Edit',
              cancelButtonText: 'Cancel'
            }
          },
          preview: {
            headerLabels: {
              from: 'From:',
              subject: 'Subject:',
              to: 'To:'
            },
            searchProjectDefaultLabel: "Didn't reply to the previous step"
          },
          sections: {
            title: '{attempt} Step',
            trigger: {
              label: 'Trigger:',
              field: 'No reply to previous Step'
            },
            triggerDays: {
              label: 'Send After:',
              placeholder: 'Select Days',
              requiredMessage: 'This field is required',
              hint: 'Selecting less days than recommended can affect your email reputation',
              options: {
                recommendedSuffix: '(best for {bulkScope} - Step {step})',
                title: '{day} {dayLabel} {recommendedSuffix}'
              }
            },
            subject: {
              label: 'Subject: *',
              placeholder: 'Enter Subject',
              requiredMessage: 'Subject is required'
            },
            emailBody: {
              requiredMessage: 'Email Body is required'
            }
          }
        },
        fields: {
          title: '1st Step',
          searchProject: {
            label: 'To: *',
            placeholder: 'Enter Search Project Name',
            noValue: 'No Search Project Selected'
          },
          bulkType: {
            hint: "Bulk Types identify the people you're sending this bulk to. Select a type for this bulk.",
            label: 'Bulk Type: *',
            placeholder: 'Select Bulk Type',
            noValue: 'No Bulk Type Selected',
            typeAndDescription: {
              Marketing: 'Marketing (Send only to Hiring Authorities)',
              Recruiting: 'Recruitment (Send only to Candidates)',
              General: 'General (Send to Everyone)'
            }
          },
          candidatesToMarket: {
            hint: `Select the candidate(s) you want to market. The bulk won't be sent to the Hiring Authorities that are currently in the same company as a selected Candidate.`,
            label: 'Candidates to Market: *',
            placeholder: 'Select Candidate(s) to market',
            noValue: 'No Candidates to Market Added'
          },
          generalBulkCategory: {
            label: 'General Category: *',
            placeholder: 'Select General Bulk category',
            noValue: 'No General Category Selected'
          },
          jobOrdersToRecruit: {
            label: 'Job Orders to Recruit: *',
            placeholder: 'Select Job Order(s) to recruit',
            noValue: 'No Job Orders to Recruit Added',
            hint: 'Select the job order(s) you want to recruit. Adding job orders to this bulk will update their activity log.',
            optionsHint:
              'Recruiting Bulk Emails will not reach Candidates from Client or Signed Companies'
          },
          template: {
            label: 'Template (optional):',
            placeholder: 'Select Template',
            noValue: 'No Template Selected'
          },
          blockResend: {
            adviceTexts: {
              disabled: 'To enable this option, you must select a template first.',
              off: 'The template will be sent to contacts who may have already received it.',
              on: "The template won't be sent to contacts who have already received it within the selected time interval."
            },
            label: 'Block Resend:',
            hint: 'This option will block the contacts who have received the selected template before. Turn on Block Resend to block contacts within a time interval.'
          },
          resendTime: {
            label: 'Within the Last:',
            placeholder: 'Select Time Interval',
            optionTitle: '{numberOfDays} Days'
          },
          subject: {
            label: 'Subject: *',
            placeholder: 'Enter Subject',
            noValue: 'No Subject Added'
          },
          attachFiles: {
            label: 'Attach Files:'
          },
          smartTags: {
            label: 'Insert Smart Tag:',
            placeholder: 'Select Smart Tag',
            hint: 'Use fields to personalize your bulk email. Select one to insert it.'
          }
        },
        validations: {
          searchProject: {
            required: 'Search project recipient is required'
          },
          bulkType: {
            required: 'Bulk type is required'
          },
          generalBulkCategory: {
            required: 'Category is required'
          },
          subject: {
            required: 'Subject is required'
          },
          emailBody: {
            required: 'Bulk Email body is required'
          },
          templateEmailBody: {
            required: 'A Body is required to create this template'
          },
          resendTime: {
            required: 'Time Interval is required'
          },
          marketCandidates: {
            required: 'Candidate(s) to market is required'
          },
          jobOrdersToRecruit: {
            required: 'Job Order is required'
          },
          scheduleDate: {
            required: 'Schedule Date is required'
          },
          scheduleTime: {
            required: 'Schedule Time is required'
          },
          templateParentFolder: {
            required: 'Directory folder is required to organize your template'
          },
          templateName: {
            required: 'Name is required'
          }
        },
        smartTags: {
          validations: {
            wellWritten:
              'The {field} contains incorrect smart tags. Make sure all smart tags are well-written',
            unsupportedSmarTag:
              'The {field} contains an invalid smart tag. To send the bulk, the following smart tag must be removed: {smartTag}',
            atLeastOne: 'At least one smart tag (recipient) is required'
          }
        },
        marketingOptions: {
          blockCompanies:
            "Block Hiring Authorities from the same Candidate's Company in all its locations",
          blockSigned: 'Block all Signed or Client Companies in this Search Project',
          allowMarketingCandidates: 'Allow the Bulk to reach Candidates in this Search Project',
          blockAssociatedCompanies:
            "Block Hiring Authorities from the Candidates' Associated Companies"
        },
        recruitingOptions: {
          allowRecruitHirings: 'Allow the bulk to reach Hiring Authorities in this Search Project'
        },
        sendThroughOutlook: {
          alertAction: 'Learn More',
          checkboxLabel: 'Send bulk through Outlook.',
          warning:
            "Max {initialQuota} daily emails via Outlook ({remainingQuota}/{initialQuota} available until 11:59 PM CST); exceeding will go to Exceeded Quota section in the bulk stats, where you'll be able to manage them. To learn more, click the button."
        },
        warnings: {
          beforeSending:
            "Once this sequence starts, you can edit and cancel steps that haven't been sent yet. Steps that are being sent can't be edited nor canceled. Review your messages and Search Projects before starting.",
          generalCategory:
            'Do not use General Bulks to promote inventory, for that please use Marketing or Recruitment types',
          quota: {
            main: 'Available Quota: {remainingQuota} of {initialQuota} recipients (resets at 11:59 PM CT).',
            sequence:
              "Automatic sends use your bulk credits on the day the step runs and go to recipients who didn't reply to the previous step."
          }
        },
        emailVariants: {
          action: 'Create Email Variant',
          body: "To improve your bulk's deliverability and prevent being flagged as spam, it is ESSENTIAL for you to split your Search Projects into smaller groups and use variants of your email subject and body. You can use our email variant generator."
        },
        signatureInfo: {
          selectOption: {
            value: '{{your_signature}}',
            name: 'Email Signature (Automatically included when sending the bulk)',
            type: 'sender'
          },
          helperText:
            'The signature will be automatically included and visible upon sending the bulk, as well as in the bulk preview.'
        },
        errors: {
          customSmartTagsValidations:
            'At least one required option property is missing on bulkEmailCutomValidations options param'
        },
        templates: {
          restore: {
            title: 'Restore {entity}',
            sections: {
              name: {
                title: '{entity} Name'
              },
              folder: {
                title: 'Directory Folder',
                placeholder: 'Choose folder',
                requiredMessage: 'Directory Folder is Required'
              }
            }
          }
        }
      },
      layout: {
        composeButton: 'Compose',
        userFiltersPlaceholder: 'Bulks to Show',
        menuItemsTitles: {
          sent: 'Sent',
          template: 'Templates',
          drafts: 'Drafts',
          schedule: 'Scheduled Bulks',
          optout: 'Opt in / Opt out'
        }
      },
      preview: {
        mailMeta: {
          attachments: {
            title: 'Attachments'
          },
          blockResend: {
            title: 'Block Resend'
          },
          booleanOptions: {
            yes: 'Yes',
            no: 'No'
          },
          bulktTypeEntities: {
            tooltip: 'Go to {entity} Profile',
            entities: {
              candidate: "Candidate's",
              joborder: "Job Order's"
            }
          },
          createdOn: {
            title: 'Created on'
          },
          sendingOn: {
            title: 'Sending on'
          },
          subject: {
            defaultValue: '(No Subject)'
          },
          from: {
            title: 'From'
          },
          to: {
            title: 'To',
            renderValueTitle: 'Go to Search Project Preview',
            defaultValue: '(No Search Project selected)'
          },
          bulkType: {
            title: 'Bulk Type',
            defaultValue: '(No Bulk Type selected)'
          },
          generalCategory: {
            title: 'General Category',
            defaultValue: '(No General Category selected)'
          },
          isSchedule: {
            title: 'Bulk Scheduled'
          },
          candidatesToMarket: {
            title: 'Candidates to Market',
            defaultValue: '(No Candidates to market selected)',
            config: {
              blockHirings: 'Block HAs from same company and location',
              blockSignedClientCompanies: 'Block signed and client companies',
              allowReachingCandidates: 'Allow Candidate reach',
              blockAssociatedCompanies: 'Block Associated Companies'
            }
          },
          jobOrdersToRecruit: {
            title: 'Job Orders to recruit',
            defaultValue: '(No Job Orders to recruit selected)',
            config: {
              allowReachingHirings: 'Allow Hiring Authority reach'
            }
          },
          template: {
            title: 'Template'
          },
          emailBody: {
            defaultValue: '(No content to display)'
          },
          showButton: {
            text: 'Show {adverb}',
            adverbs: {
              less: 'less',
              more: 'more'
            }
          }
        },
        sequences: {
          canceledAlert: 'Sequence Canceled by {noun} on {date}',
          title: '{step} Step',
          delayDetail: '- {days} {daysLabel} no reply',
          actions: {
            edit: 'Edit',
            cancelStep: 'Cancel Step'
          },
          dayLabels: {
            singular: 'Day',
            plural: 'Days'
          }
        }
      },
      schedule: {
        bulkFormAlert: {
          scheduledFailed: `This bulk's scheduling has failed. Your action is required to reschedule.`,
          remainingTime: `{quantity} {unitOfTime} remaining. This bulk will be sent on {formattedDate}`
        },
        errors: {
          beforeActualDateTime: `Bulks can't be scheduled in the past. Please set a schedule time that hasn't occurred.`,
          emailCouldntBeSent: 'Send Failure. Open bulk to reschedule or send.'
        }
      },
      stats: {
        title: 'Bulk Stats Management',
        details: {
          title: 'Bulk Details',
          sections: {
            from: 'From',
            searchProject: 'Search Project',
            bulkType: 'Bulk Type',
            sentDate: 'Sent on'
          }
        },
        alerts: {
          learnMoreButton: 'Learn More',
          info: {
            resume: {
              description: `Here are the latest stats of the bulk you sent {formattedDate}. These may change
              because they're updated on time. To learn about email dropping due to frequency rates, click the <b>Learn More</b> button`
            }
          },
          openInfo:
            "This metric should be used with caution. If a recipient has images disabled, their open may not be counted. Conversely, privacy features like Apple's Mail Privacy Protection (MPP) automatically load content, which can artificially inflate your open rates. Click the button to learn more."
        },
        cards: {
          viewDetails: 'View Details',
          pending_emails: {
            description: 'Emails waiting to be sent.',
            title: 'Queued'
          },
          quota_exceeded_emails: {
            description:
              'Emails not sent because quota was exceeded. You can create a search project and schedule a new bulk for later.',
            title: 'Exceeded Quota'
          },
          sent_emails: {
            description:
              'Recipients that received the bulk. This number updates every time the bulk reaches a new email address.',
            title: 'Delivered Emails'
          },
          open_emails: {
            description: 'Delivered emails that have been opened by the recipients.',
            title: 'Open'
          },
          spam_emails: {
            description: `Delivered emails that recipients marked as spam or unsubscribed upon receiving it.`,
            title: 'Exclusion Reports'
          },
          click_emails: {
            description: `Delivered emails that recipients clicked the bulk’s link (One click per recipient).`,
            title: 'Links Clicked-through'
          },
          bounced_emails: {
            description: `Emails bounced due to the recipient’s policies or filtering systems. Click to view the reason for each recipient.`,
            title: 'Bounced'
          },
          unreachable_emails: {
            description:
              'Recipients that can’t receive our emails due to no longer existing or the recipient blocked our IP addresses/email domain. Click to view the reason for each recipient.',
            title: 'Unreachable'
          },
          dropped_emails: {
            description: `Emails not sent due to business rules (e.g., Recruiting a Client, Block Resend). Click to view the reason for each recipient.`,
            title: 'Dropped'
          },
          fixable_emails: {
            description: `Recipients that didn’t receive the bulk due to an invalid or missing email address. Click to view the reason for each recipient.`,
            title: 'Fixable'
          },
          unsubscribe_emails: {
            description: `Recipients that were already unsubscribed before sending the bulk. Click to view the reason for each recipient.`,
            title: 'Unsubscribed'
          },
          original_meant_recipients: {
            description:
              'Full Stats = Delivered + Bounced + Unreachable + Dropped + Fixable + Unsubscribed',
            title: 'Full Stats Overview'
          },
          reply_emails: {
            description: 'Manual replies sent by the recipient.',
            title: 'Direct Replies'
          },
          automatic_reply_emails: {
            description: "Automatic replies sent by the recipient's email system.",
            title: 'Automated Replies'
          }
        },
        resume: {
          openRate: {
            title: 'Open Rate',
            description:
              'The percentage of sent emails that were opened by the recipients (Only one opening per recipient).'
          }
        }
      },
      success: {
        addSequenceStep: {
          title: 'Sequence Steps Successfully Added'
        },
        addToOptOut: {
          title: 'Email Opted-Out Successfully',
          body: '{email} will no longer receive bulks'
        },
        archiveBulkTemplate: {
          title: 'Bulk Template Successfully Archived',
          body: 'Stored in the Archived folder for {days} days until deletion'
        },
        archiveBulkTemplateFolder: {
          title: 'Bulk Folder Successfully Archived',
          body: 'Stored in the Archived folder for {days} days until deletion'
        },
        cancelSequence: {
          title: 'Sequence Successfully Canceled'
        },
        cancelSequenceStep: {
          title: 'Sequence Step Successfully Canceled'
        },
        createBulkTemplate: {
          title: 'Bulk Template Successfully Created'
        },
        createBulkTemplateFolder: {
          title: 'Folder Successfully Created'
        },
        deleteBulkEmailDraft: {
          title: 'Bulk Draft Successfully Deleted'
        },
        deleteScheduledBulkEmail: {
          title: 'Scheduled Bulk Successfully Deleted'
        },
        deleteTemporaryAttachments: {
          title: 'File Successfully Deleted'
        },
        removeAttachments: {
          template: {
            title: 'File Removed',
            body: 'The file was removed successfully'
          }
        },
        removeFromOptOut: {
          title: 'Email Opted-In Successfully',
          body: '{email} will receive bulks again'
        },
        restoreBulkTemplate: {
          title: 'Template Restored Successfully',
          body: '"{templateName}" restored in {destinationFolderName}'
        },
        restoreBulkTemplateFolder: {
          title: 'Folder Successfully Restored',
          body: '"{folderName}" restored in {destinationFolderName}'
        },
        scheduleBulkEmail: {
          title: 'Bulk Successfully Scheduled',
          body: 'Sending on {formattedDate}'
        },
        sendBulkDraft: {
          title: 'Bulk Draft Successfully Saved',
          body: 'Stored in the Drafts section under Bulks'
        },
        sendBulkEmail: {
          title: 'Bulk Successfully Sent'
        },
        sendBulkSequence: {
          title: 'Sequence Successfully Sent'
        },
        sendScheduledBulkNow: {
          title: 'Bulk Successfully Sent'
        },
        updateBulkEmailDraft: {
          title: 'Bulk Draft Successfully Updated'
        },
        updateBulkTemplate: {
          title: 'Bulk Template Successfully Updated'
        },
        updateBulkTemplateFolder: {
          title: 'Bulk Folder Successfully Updated'
        },
        updateScheduledBulkDateTime: {
          title: 'Bulk Successfully Rescheduled',
          body: 'Sending on {formattedDate}'
        },
        updateScheduledBulkEmail: {
          title: 'Scheduled Bulk Successfully Updated',
          body: 'Sending on {formattedDate}'
        },
        updateSequenceStep: {
          title: 'Sequence Step Successfully Edited'
        }
      },
      templateActions: {
        actions: {
          newTemplate: 'New Template',
          newFolder: 'New Folder'
        },
        templateFolder: {
          folderName: '1.- Folder Name * ',
          selectDirectory: '2.- Select Directory Folder *',
          directoryFolder: '2.- Directory Folder'
        },
        templateDrawer: {
          templateInfo: '1.- Template Info',
          selectDirectory: '2.- Select Directory Folder *',
          directoryFolder: '2.- Directory Folder *',
          templateContent: '3.- Template Content'
        },
        addEmailOptInForm: {
          initialWarning: 'Please enter the email that will no longer receive emails from gpac',
          reasonOptOut: 'Reason to Opt Out *',
          notes: 'Notes'
        },
        tooltipText:
          'You can only create new folders and templates of your own. Please go to "My Folders" to enable the options.'
      },
      utils: {
        alert: {
          error: {
            getMappedBulkData: {
              body: 'Error mapping bulk email data',
              title: 'Missing data'
            },
            updateByBulkType: {
              body: `Bulk type doesn't match with any update method`,
              title: 'Unable to update bulk'
            }
          }
        }
      },
      emailGenerator: {
        title: 'Bulk Email Generator',
        craftingEmail: 'I’m crafting an email to promote these {pluralEntity}:',
        headerLabel: 'Search Project to Bulk:',
        ratingErrorTitle: 'Rating Error',
        ratingErrorMessage:
          'Failed to rate this generated response. Please contact Fortpac Support.',
        submitButtonName: 'Continue & Edit',
        notEnoughData: {
          title: 'Not Enough Data'
        },
        generalError: {
          title: 'Error Generating Email',
          message: 'There was an error generating the email. Please contact Fortpac Support.'
        }
      }
    },
    searchProjects: {
      alerts: {
        success: {
          generalTitle: '{entity} Successfully {action}',
          archiveGeneralBody: 'Stored in the Archived folder',
          actionToSearchProjectName: '{action} to {searchProjectName}',
          collaborations: {
            add: '{entitiesLength} {entity} added to {searchProjectName}',
            remove: '{entitiesLength} {entity} removed from {searchProjectName}',
            userAlreadySelected: {
              title: 'Collaborator Already Added',
              body: '{name} is already in this Search Project. Select a different collaborator.'
            }
          },
          splitsBody: 'Split into {entitiesLength} new {entity}',
          actions: {
            add: 'Added',
            archive: 'Archived',
            copy: 'Copied',
            create: 'Created',
            edit: 'Updated',
            extract: 'Extracted',
            move: 'Moved',
            remove: 'Removed',
            restore: 'Restored',
            split: 'Split'
          }
        },
        error: {
          general: {
            title: 'Unexpected Error While {action} {entity}'
          },
          actions: {
            add: 'Adding',
            archive: 'Archiving',
            copy: 'Copying',
            create: 'Creating',
            delete: 'Deleting',
            edit: 'Editing',
            extract: 'Extracting',
            move: 'Moving',
            remove: 'Removing',
            restore: 'Restoring',
            split: 'Spliting'
          }
        },
        entities: {
          collaborator: 'Collaborator',
          collaborators: 'Collaborators',
          contacts: 'Contacts',
          folder: 'Folder',
          records: 'Records',
          searchProject: 'Search Project',
          searchProjects: 'Search Projects'
        }
      },
      dialogs: {
        archiveFolder: {
          title: 'Archive Folder',
          message:
            'The folder and its content will be stored in the <b>Archived</b> folder.<br>Are you sure you want to archive this folder?',
          confirmButtonText: 'Archive Folder',
          cancelButtonText: 'Cancel'
        },
        archiveMultipleSearchProjects: {
          dialog: {
            title: 'Archive Search Projects',
            message:
              'The selected Search Projects will be moved to the <b>Archived</b> folder.<br>Any bulk currently in process or scheduled for these Search Projects <b>will be sent</b> as planned.<br>Are you sure you want to archive these Search Projects?',
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel'
          }
        },
        archiveSearchProject: {
          dialog: {
            title: 'Archive Search Project',
            message:
              'The Search Project <b>{searchProjectName}</b> will be moved to the <b>Archived</b> folder.<br>Any bulk currently in process or scheduled for this Search Project <b>will be sent</b> as planned.<br>Are you sure you want to archive this Search Project?',
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel'
          }
        },
        restoreSearchProject: {
          main: {
            title: 'Restore {subject}',
            message: `The selected {subject} will be restored to their owners' folders. Are you sure you want to restore the {subject}?`,
            confirmButtonText: 'Restore',
            cancelButtonText: 'Cancel'
          },
          subject: {
            singular: 'Search Project',
            plural: 'Search Projects'
          },
          detailsTitles: {
            name: 'Search Project Name',
            archivedDate: 'Archived Date'
          }
        },
        splitSearchProject: {
          title: 'Split Search Project',
          message: `You're about to split <b>{searchProjectName}</b> into {parts} new Search Projects. Are you sure you want to split this Search Project?`,
          confirmButtonText: 'Split',
          cancelButtonText: 'Cancel'
        }
      },
      mainPage: {
        title: 'Search Projects',
        dataTable: {
          toolbar: {
            moveItemsMenuButton: {
              title: 'Move to Folder',
              menuItems: {
                moveToExisting: 'Move to Existing Folder',
                moveToNew: 'Move to New Folder'
              }
            },
            archiveMultipleButton: {
              title: 'Archive'
            },
            restoreMultipleButton: {
              title: 'Restore All'
            }
          },
          actions: {
            sendBulk: 'Send Bulk',
            restore: 'Restore'
          }
        },
        emptyStates: {
          noFolders: {
            title: "Couldn't Retrieve Information",
            subtitle: 'Please refresh the page. If the problem persist, contact FortPac Support.'
          }
        },
        filtersTitles: {
          mine: 'My Search Projects',
          archived: 'Archived'
        },
        layoutContainer: {
          foldersList: {
            actions: {
              newFolder: 'New Folder'
            }
          },
          header: {
            menuItemsTitles: {
              edit: 'Edit',
              archive: 'Archive',
              restore: 'Restore'
            }
          }
        },
        searchBox: {
          placeholder: 'Search by Search Project name',
          groupsTitles: {
            mine: 'MY SEARCH PROJECTS',
            other: "OTHER RECRUITER'S PUBLIC SEARCH PROJECTS"
          }
        },
        sideFilters: {
          isPrivate: {
            private: 'Private',
            public: 'Public'
          },
          isMasterList: {
            show: 'Show Only Master Lists',
            exclude: 'Exclude Master Lists'
          }
        }
      },
      forms: {
        addItemsToSearchProject: {
          title: 'Add to my Search Projects'
        },
        searchProject: {
          titles: {
            create: 'New Search Project',
            edit: 'Edit Search Project',
            extractCompaniesContacts: 'Extract Contacts to New Search Project'
          },
          sections: {
            titles: {
              details: 'Search Project Details',
              extractCompaniesContacts: 'Select Contacts to Extract from Companies',
              extractionDetails: 'Extraction Details',
              geoPolygon: 'Locations Polygon',
              importOptions: 'Import Options',
              industryDetails: 'Industry Details',
              markAsMasterList: 'Mark as Master List',
              parentFolder: "Select Search Project's Location",
              seatCount: 'Seat Count'
            },
            owner: {
              placeholder: 'Search Project Owner *',
              requiredMessage: 'Search Project Owner is required',
              sameCollaboratorAsOwnerMessage:
                "Collaborators can't be assigned as Search Project owners."
            },
            name: {
              label: 'Search Project Name *',
              requiredMessage: 'Search Project name is required',
              minLengthMessage: 'Search Project name must have at least 5 characters'
            },
            visibility: {
              private: '* Only you can access to this Search Project',
              public: '* Everyone can access this Search Project'
            },
            parentFolder: {
              placeholder: 'Parent Folder*',
              requiredMessage: 'Parent Folder is required'
            },
            extractCompaniesContacts: {
              options: {
                addEmployees: 'Employees',
                addHiringAuthorities: 'Hiring Authorities'
              },
              atLeastOnePositiveMessage: 'Select at least one option',
              nameSufix: 'Extracted Contacts',
              filtersHint:
                'This extraction will include only the Companies in the Search Project that match your filters. Companies outside these filters will be excluded. This will extract ',
              countLoadErrorHint:
                "The number of Companies for this extraction can't be determined. Close and reopen the drawer to recalculate.",
              noCompaniesHint:
                'No Companies in this Search Project match the current filters. Update your filters to continue with extraction.',
              details: {
                extractingFrom: 'Extracting from',
                companiesToExtract: 'Companies to Extract'
              }
            },
            markAsMasterList: {
              label: 'This Search Project is a Master List'
            },
            geoPolygon: {
              label: 'Enter Polygon Text'
            },
            seatCount: {
              label: 'Seat Count',
              atLeastOneMessage: 'Value should be at least 1',
              shouldBeInteger: 'This field only accepts integers, not decimals are allowed'
            },
            industryDetails: {
              fields: {
                industrySpecialty: {
                  placeholder: 'Industry: Specialty *'
                },
                position: {
                  placeholder: 'Position'
                },
                subspecialty: {
                  placeholder: 'Subspecialty'
                }
              },
              alertInfo:
                "AI will auto-assign the Industry based on prospect information. If it's unsure, the default category you choose below will be used"
            },
            importOptions: {
              fields: {
                addToSearchProjectOption: 'Add to Search Project anyway',
                importContactsAs: 'Import contacts as:',
                skipDuplicates: 'If a contact already exists',
                skipOption: 'Skip existing contacts',
                company: {
                  skipDuplicates: 'If a company already exists',
                  skipOption: 'Skip existing companies'
                }
              }
            }
          }
        },
        restoreFolder: {
          title: 'Restore Folder',
          sections: {
            parentFolder: {
              title: "Select the folder's location",
              placeholder: 'Parent Folder'
            }
          }
        },
        restoreSearchProject: {
          title: 'Restore {subject}',
          subject: {
            singular: 'Search Project',
            plural: 'Search Projects'
          },
          sections: {
            name: {
              title: 'Search Project Name'
            },
            parentFolder: {
              title: "Select the Search Project's location",
              placeholder: 'Parent Folder'
            }
          }
        },
        splits: {
          title: 'Split Search Project',
          sections: {
            resume: {
              title: 'Information',
              infoTitles: {
                name: 'Search Project Name',
                totalItems: 'Total Items',
                visibility: 'Visibility'
              }
            },
            partsSelection: {
              title: 'Split Into*',
              options: {
                title: '{0} Search Projects',
                quantity: {
                  two: '2',
                  three: '3',
                  more: 'More'
                }
              },
              validations: {
                defaultOptions: {
                  required: 'The number of splits is required',
                  splitsGreatherThanItems: `The number of splits can't be greater than the number of items in your current Search Project`
                },
                customSplits: {
                  max: '$ref{searchProjects.forms.splits.sections.partsSelection.validations.customSplits.numberOfSplits.max} splits at a time is the maximum number allowed for each Search Project',
                  min: 'At least $ref{searchProjects.forms.splits.sections.partsSelection.validations.customSplits.numberOfSplits.min} splits are required to split a Search Project',
                  shouldBeInteger:
                    'Enter a number between $ref{searchProjects.forms.splits.sections.partsSelection.validations.customSplits.numberOfSplits.min} and $ref{searchProjects.forms.splits.sections.partsSelection.validations.customSplits.numberOfSplits.max} (no decimals)',
                  numberOfSplits: {
                    max: process.env.REACT_APP_SEARCH_PROJECT_MAX_SPLIT,
                    min: 2
                  }
                }
              }
            },
            splitInformation: {
              title: 'Split Search Projects Information',
              subtitle: `You can edit the Search Project's name if needed. To differentiate them, the split number will be added automatically.`,
              label: 'Search Project Name',
              resume: {
                name: '{searchProjectName} | Part (Nº) | {date}',
                totalItems: '{totalItems} in each Search Project (approx.)'
              },
              validations: {
                required: 'The search project name is required'
              }
            },
            parentFolder: {
              title: "Select Search Projects' location",
              placeholder: 'Parent Folder*'
            }
          }
        }
      },
      folderForm: {
        title: {
          generalTitle: '{action} Folder',
          actions: {
            create: 'Create',
            edit: 'Edit',
            moveToExisting: 'Move to Existing',
            moveToNew: 'Move to New'
          }
        },
        sections: {
          folderName: {
            title: "Enter Folder's name",
            placeholder: 'Folder Name *'
          },
          parentFolder: {
            title: 'Select Folder',
            placeholder: 'Parent Folder *'
          }
        },
        validations: {
          required: {
            folderName: "Folder's name is required"
          }
        }
      },
      activityLog: {
        drawer: {
          title: 'Search Project History Log',
          content: 'History Log'
        }
      },
      collabsForm: {
        title: 'Search Project Collaborations',
        dialogs: {
          saveCollabsChanges: {
            dialog: {
              title: 'Remove Collaborators',
              message:
                'The {person} will no longer have permission to edit or send bulks to this Search Project. Are you sure you want to remove {determiner} {person}?',
              confirmButtonText: 'Remove',
              cancelButtonText: 'Keep'
            },
            singular: {
              person: 'collaborator',
              determiner: 'this'
            },
            plural: {
              person: 'collaborators',
              determiner: 'these'
            }
          },
          discardCollabsChanges: {
            title: 'Discard Changes',
            message:
              'If you close the window without saving, the changes in this Search Project will be lost. Are you sure you want to discard these changes?',
            confirmButtonText: 'Save Changes',
            cancelButtonText: 'Discard Changes'
          }
        }
      },
      menuItems: {
        add: {
          title: 'Add to Search Project'
        },
        create: {
          title: 'Create new Search Project'
        },
        remove: {
          title: 'Remove From this Search Project'
        },
        copy: {
          toExisting: {
            title: 'Copy to an Existing Search Project'
          },
          toNew: {
            title: 'Copy to a New Search Project'
          }
        },
        move: {
          toExisting: {
            title: 'Move to an Existing Search Project'
          },
          toNew: {
            title: 'Move to a New Search Project'
          }
        },
        map: {
          add: {
            title: 'Existing Search Project'
          },
          create: {
            title: 'New Search Project'
          }
        }
      },
      preview: {
        actions: {
          archivedSearchProject: {
            title: 'Restore'
          },
          editIconButton: {
            title: 'Edit Search Project'
          },
          moreOptions: {
            title: 'More Options',
            menuItems: {
              archive: 'Archive',
              edit: 'Edit',
              extractCompaniesContacts: 'Extract Contacts',
              historyLog: 'View History Log',
              manageCollabs: 'Manage Collaborators',
              split: 'Split'
            }
          }
        },
        buttons: {
          removeItems: 'Remove from Search Project',
          sendBulk: 'Send Bulk',
          sendBulkDisabled: `No items to bulk (Companies can't receive bulks).`
        },
        dialogs: {
          removeItems: {
            title: 'Remove Selected Items',
            message:
              'These items will no longer appear on the Search Project "{spName}". Are you sure you want to remove the selected items?',
            confirmButtonText: 'Remove',
            cancelButtonText: 'Keep'
          }
        },
        extraRenderers: {
          NAChip: {
            hint: 'No Company is linked to this Candidate. Add a Company to start marketing it.',
            label: 'N/A',
            variant: 'danger'
          }
        },
        infoMessages: {
          addApplicants:
            "Applicants from Talent Pool are about to be imported and added to your Search Project. You'll receive an email with the total number of added items once the process has finished.",
          inProgress:
            'Your Search Project is being populated. An email will be sent when the process is finished or you can refresh this page.'
        }
      },
      profiles: {
        dialogs: {
          removeProfile: {
            title: 'Remove from Search Project',
            message:
              'This {entity} will no longer appear on the Search Project "{spName}". Are you sure you want to remove {itemName} from this Search Project?',
            confirmButtonText: 'Remove',
            cancelButtonText: 'Keep'
          }
        },
        tabs: {
          addButtonText: 'Add to Search Project',
          emptyPlaceholderTitle: 'No Search Projects to Show',
          emptyPlaceholderSubtitle:
            'To add this {entity} to a Search Project, click the “Add to Search Project” button.'
        }
      }
    },
    bulkEmailDashboard: {
      title: 'Bulk Emails',
      infoAlert: `* Bulk activity updates every hour aproximately. Last updated on {lastUpdate}`,
      section: {
        name: 'dashboardBulkEmail',
        titles: {
          totalSent: 'Total Bulks Sent',
          trends: 'Sent Bulk Trends',
          ratio: 'Open Ratio',
          manualReplies: 'Direct Replies',
          automaticReplies: 'Automated Replies',
          totalStats: 'Total Bulk Stats',
          withActivity: 'Bulk Overview'
        }
      }
    },
    phoneDashboard: {
      title: 'Calls & Texts',
      sections: {
        totalCalls: {
          title: 'Total Calls'
        },
        callSummaryTable: {
          title: 'Total Calls',
          primaryHeaders: {
            grandTotal: 'Grand Total',
            inbound: 'Inbound',
            outbound: 'Outbound'
          },
          secondaryHeaders: {
            callResult: 'Call Result',
            connected: 'Connected',
            missed: 'Missed',
            notConnected: 'Not Connected',
            total: 'Total'
          },
          emptyState: {
            message: 'There is no data with the selected filters'
          },
          error: {
            title: 'Error summarizing calls',
            message: 'Error fetching data'
          },
          footer: {
            callLastUpdate:
              '* Calls and Min may update from 30 min up to 1 hour after the call. Last updated on {date} at ',
            summaryTime:
              '· <b>Total call Time & Av Handle Time:</b> Only include Accepted, Connected or Voicemail calls.',
            ringCentralDisclaimer: `* Due to their classification method, numbers may differ from FortPac and RingCentral. RingCentral Analytics doesn't guarantee the accuracy of its data; FortPac is a more reliable source for call metrics.`,
            outboundCalls:
              '· <b>Outbound:</b> Includes calls marked as Outbound with results: Call connected, Accepted, or Voicemail.',
            inboundCalls:
              '· <b>Inbound:</b> Includes calls marked as Inbound with results: Call connected, Accepted, or Voicemail.',
            missedCalls: '· <b>Missed:</b> Includes calls with Missed or Reply results.',
            notConnectedCalls:
              '· <b>Not Connected:</b> Includes calls with Busy, Hang Up, No Answer, Wrong Number, Call Failed, Call Failure, Not Allowed, IP Phone Offline, Stopped, and Blocked results.'
          }
        },
        callTrends: {
          title: 'Call Trends'
        },
        calls: {
          title: 'Calls'
        },
        totalTexts: {
          title: 'Total Texts'
        },
        textTrends: {
          title: 'Text Trends'
        },
        texts: {
          title: 'Texts'
        },
        noPhoneActivity: {
          noNewCalls: 'No New Calls',
          noNewTexts: 'No New Texts',
          title: 'No phone Activity'
        }
      }
    },
    map: {
      entityInfo: {
        statusLabel: 'Status',
        lastActivityLabel: 'Last activity',
        specialtyDetails: {
          separator: ' · ',
          teamsSeparator: ' | ',
          industryLabel: 'Industry',
          specialtyLabel: 'Specialty',
          subspecialtyLabel: 'Subspecialty'
        }
      },
      inventory: {
        locationHint:
          "You're now viewing results based on the visible area of the map. The location filters are no longer applied.",
        alertTitle: 'Not enough filters applied',
        alertBody: 'Apply at least an Industry, Team or Location filter to show results',
        popover: {
          industrySpecialityLabel: 'INDUSTRY · SPECIALTIES · SUBSPECIALTIES',
          recruiterLabel: 'RECRUITER'
        }
      },
      dig: {
        recruiterInfo: {
          team: 'Team {coach}'
        },
        noResults: {
          title: "We couldn't find what you're looking for!",
          subtitle: 'Maybe try changing your search filters'
        },
        alertBody: 'Select at least one filter'
      }
    },
    resumeSearch: {
      title: 'Advanced Search',
      emptyState: {
        title: "Let's find the right candidates",
        subtitle: 'Set your filters to get started; you can always adjust them later',
        cta: 'Choose filters'
      },
      resumesList: {
        results: '{totalResults} results',
        emptyState: {
          title: 'No resumes found',
          subtitle: 'Try adjusting your search criteria or filters'
        },
        selection: {
          selectPage: 'Select {number} items on this page',
          selectAll: 'Select all {number} items',
          clearSelection: 'Clear selection',
          selectedCount: '{count} selected'
        }
      },
      resumeCard: {
        sections: {
          contactInfo: 'Contact Info',
          experience: 'Experience',
          education: 'Education',
          skills: 'Skills',
          certifications: 'Certifications',
          associations: 'Professional Associations'
        },
        toggleContactInfo: 'Toggle contact info',
        metadata: {
          createdAt: 'Created {date}',
          recruiter: 'Recruiter: {recruiter}',
          lastActivity: 'Last activity: {activity}'
        },
        actions: {
          save: 'Save',
          hide: 'Hide'
        },
        currentYear: 'Present',
        morePositions: '+{count} more positions',
        showAll: 'Show all ({count})',
        showFewer: 'Show fewer',
        moreAssociations: '+{count} more association{plural}',
        roleAtCompany: '{role} at {company}',
        yearsExperienceSuffix: '{count} yrs exp',
        startAvailability: 'Start: {value}',
        relocateLabel: 'Willing to relocate',
        teamSeparator: ' • ',
        contactInfo: {
          email: 'Email',
          altEmail: 'Alt email',
          phone: 'Phone',
          phoneOrdinal: 'Phone {count}',
          phoneWithUse: '{use} Phone',
          linkedIn: 'LinkedIn'
        }
      },
      sort: {
        label: 'Sort by',
        options: {
          best_match: 'Best match',
          name_asc: 'Name A–Z',
          name_desc: 'Name Z–A',
          newest: 'Newest first',
          oldest: 'Oldest first'
        }
      },
      pagination: {
        showing: 'Showing {startItem}-{endItem} of {totalItems} results',
        showLabel: 'Show',
        perPageLabel: 'per page',
        firstPage: 'First Page',
        lastPage: 'Last Page',
        nextPage: 'Next Page',
        previousPage: 'Previous Page'
      },
      filters: {
        aiSmartSearchPlaceholder:
          'Describe the candidate you are looking for, i.e: "Project Managers with leadership experience and master\'s degrees in Philadelphia, PMP or CAMP certifications"',
        priorities: {
          mustHave: 'Must Have',
          canHave: 'Can Have',
          doesntHave: "Doesn't Have"
        },
        placeholders: {
          activities: 'Choose activities',
          certifications: 'Choose Certifications',
          cities: 'Choose Cities',
          companies: 'Choose Companies',
          degrees: 'Choose Degrees',
          educationsIssuingOrganizations: 'Choose Schools',
          email: 'Type an email',
          emailSubscriptionStatus: 'Choose a status',
          industry: 'Choose Industries',
          jobFunctions: 'Choose Job Functions',
          keywords: 'Choose keywords',
          languages: 'Choose languages',
          majors: 'Choose Majors',
          names: 'Choose names',
          openToRelocation: 'Choose an option',
          phoneNumber: 'Type a phone number',
          positions: 'Choose Positions',
          professionalAssociations: 'Choose Professional Associations and Members',
          reasonsForLooking: 'Choose Reasons',
          recruiters: 'Choose Recruiters',
          relocationDestinations: 'Choose destinations',
          skills: 'Choose Skills',
          specialty: 'Choose Specialties',
          states: 'Choose States',
          statuses: 'Choose statuses',
          subspecialty: 'Choose Subspecialties',
          teams: 'Choose teams',
          timesToStart: 'Choose availability',
          types: 'Choose types',
          url: 'Type or paste URL',
          workPreferences: 'Choose Workplace Types'
        },
        names: {
          activities: 'Activity',
          AISearch: 'AI Search',
          certifications: 'Certifications',
          certifyingOrganizations: 'Certifying Organizations',
          cities: 'Cities',
          companies: 'Companies',
          createdAt: 'Created Date',
          degrees: 'Degrees',
          educationsIssuingOrganizations: 'Schools',
          email: 'Email',
          industry: 'Industries',
          jobFunctions: 'Job Functions',
          keywords: 'Keywords',
          languages: 'Languages',
          majors: 'Majors',
          name: 'Name',
          openToRelocation: 'Open to Relocation',
          phoneNumber: 'Phone Number',
          positions: 'Positions',
          professionalAssociations: 'Professional Associations and Memberships',
          reasonsForLooking: 'Reasons for Looking',
          recruiters: 'Recruiters',
          relocationDestinations: 'Relocation Destinations',
          salary: 'Salary',
          skills: 'Skills',
          specialty: 'Specialties',
          states: 'States',
          statuses: 'Status',
          subspecialty: 'Subspecialties',
          teams: 'Teams',
          timesToStart: 'Times to Start',
          types: 'Type',
          url: 'LinkedIn URL',
          workPreferences: 'Workplace Type'
        },
        groups: {
          candidate: 'Candidate',
          industry: 'Industry',
          location: 'Location',
          educationQualifications: 'Education & Qualifications',
          experience: 'Experience',
          workPreferences: 'Work Preferences',
          availability: 'Availability',
          activity: 'Activity',
          organization: 'Organization'
        },
        footer: {
          clearSearch: 'Clear Search',
          advancedSearch: 'Apply'
        },
        leaveConfirmation: "You have applied filters that aren't saved. Leave and lose them?",
        addFilter: 'Add {title}',
        salary: {
          typeLabel: 'Per hour / Per year',
          none: 'None',
          min: 'Min',
          max: 'Max',
          chooseTypeAndRange: 'Choose Type and Range'
        },
        city: {
          searchPlaceholder: 'Enter a city...',
          defaultPriorityShortLabel: 'Must'
        }
      }
    },
    candidates: {
      listing: 'Listing',
      editDataSheet: {
        contentPageTitle: 'Edit Candidate Data Sheet',
        title: 'Candidate Data Sheet',
        subheader: 'Fields marked with * are required',
        uiMessages: {
          warning: 'Please fill in the required fields',
          error: 'Some fields have inconsistencies or are missing information',
          skillsError:
            'Please enter a valid value. Avoid using special characters; use commas to divide skills',
          complete: {
            success: 'Data Sheet Saved Successfully',
            error: 'There was an error saving the Data Sheet'
          },
          draft: {
            success: 'Data Sheet Progress Saved Successfully',
            error: 'There was an error saving the Data Sheet Progress'
          }
        }
      },
      create: {
        candidateDataSheet: {
          new: {
            title: 'Candidate Data Sheet',
            subtitle:
              'It is required to fill the Candidate Data sheet and choose the Candidate type in order to add it.'
          },
          old: {
            title: 'Write Up',
            subtitle:
              'It is required to fill the write up and choose the candidate type in order to add it *'
          }
        }
      },
      creation: {
        title: 'New Candidate',
        titleV2: 'Add Candidate',
        titleFromDirectory: 'New Candidate from Directory',
        fromResume: {
          menuOption: 'Candidate from Resume',
          title: 'Add Candidate from Resume',
          cardTitle: 'Resume',
          cardSubtitle:
            "Attach the candidates's resume and click Parse Resume. You'll receive an email to review the Candidate draft created with the information found.",
          cta: 'Parse Resume',
          secondaryButton: 'Continue without Resume',
          successTitle: 'Parsing Candidate Resume',
          successBody:
            "You'll receive an email in a couple minutes to review and complete the Candidate draft created.",
          successAlert: `Resume Parsing in Progress: Check your email -you'll be notified when Fortpac creates
              the Candidate for review`
        },
        fromResumeAlert: {
          title: 'Create From Resume File',
          description: 'Speed up the process of creating a new candidate by parsing their resume.',
          action: 'Go to Resume Parser'
        },
        mainSection: 'Personal Data',
        enterEmail: {
          section: 'To create a new Candidate, please enter the email:',
          placeholder: 'Enter a valid email *',
          confirm: {
            title: 'Edit Candidate Email',
            message:
              "By editing the email of this new Candidate, you'll lose your current progress. Edit it anyway?",
            confirmButtonText: 'Edit Email'
          }
        },
        source: {
          directory: 'from Directory',
          draft: 'from Draft',
          resumeParser: 'from Resume',
          scratch: '',
          talentPool: 'from Talent Pool'
        },
        sourceButtons: {
          scratch: {
            title: 'From Scratch',
            description: 'Start with a blank profile and enter details manually'
          },
          resume: {
            title: 'Import from Resume',
            description: "Upload a resume and auto-fill the candidate's profile"
          },
          talentPool: {
            title: 'From Talent Pool',
            description: 'Convert an Applicant into a Candidate'
          },
          directory: {
            title: 'Convert from Directory',
            description: 'Turn an existing contact into a Candidate'
          }
        },
        applicant: {
          fetch: {
            tryAgain: 'Try again',
            loading: 'Candidate information is being retrieved.',
            success: 'Candidate information was successfully retrieved.',
            error: {
              forbidden: "You don't have access to this Applicant. Please contact Fortpac Support.",
              notFound: 'The applicant could not be found. Please contact Fortpac Support.',
              serverError:
                "There was an expected error while retrieving the applicant's information. Please try again or contact Fortpac Support."
            }
          }
        },
        selectExisting: {
          message: 'You are creating a new Candidate, but you can',
          link: 'select an existing Contact or Hiring Authority',
          continueMessage: 'instead.'
        },
        selectExistingFromDirectory: {
          message: 'Choose a Contact or a Hiring Authority to add as a Candidate or',
          link: 'Create a new one.',
          placeholder: 'Search for a Contact or Hiring Authority'
        },
        hiringAuthorities: {
          title: 'Hiring Authorities',
          helper:
            "You can add the Hiring Authority later, but remember that it'll be needed to create a Job Order",
          add: 'Add Hiring Authority'
        },
        similarEmail: {
          alert:
            'The email {email} is already registered in FortPac. To proceed with this email, please click the button, or try a different email',
          alertButton: ' Continue Using Email',
          alertContinue: ' or try another email.'
        },
        duplicateEmail: {
          alert:
            "The email {email} is already in FortPac {entity} and won't be saved to avoid duplicates. If this is an error, please contact FortPac Support "
        },
        registeredInTalentPool: {
          alert:
            'The email {email} is already registered in the Talent Pool. To continue, please convert it to a Candidate directly from the Talent Pool.',
          alertButton: 'View in Talent Pool'
        },
        assignRecruiter: {
          title: 'Assign to a recruiter',
          subtitle: 'Choose a recruiter to assign this item to.',
          placeholder: 'Choose a Recruiter'
        },
        success: {
          title: 'Candidates',
          body: 'Awesome! The Candidate was created successfully'
        },
        candidateWithoutEmail: {
          title: 'Contact with No Email',
          body: 'There is no valid email in the selection'
        },
        leaveForm: {
          alertBody: 'You have unsaved changes. Are you sure you want to proceed?'
        }
      },
      profile: {
        dataSheet: {
          hint: 'To create a Placement, the Candidate Data Sheet must be filled. The completed Candidate Data Sheet will be used for future job posting and bulking integration.',
          title: 'Candidate Data Sheet',
          editButton: {
            personalData: 'Edit Information',
            old: 'Edit Write Up'
          }
        },
        resumeTab: {
          emptyModel: 'No model information available.',
          emptyState: {
            subtitle:
              'No Resumes available. Make sure a Resume is uploaded in the attachments section.'
          },
          incompatibleStructure: 'The provided file has not the structure of a valid Resume',
          parseError: 'An error occurred while parsing the Resume.',
          sections: {
            achievements: 'Achievements and Accomplishments',
            assessments: 'Assessments',
            awards: 'Awards, Honors and Recognitions',
            certifications: {
              title: 'Certifications and Licenses',
              fields: {
                issuedDate: 'Issued Date',
                expiryDate: 'Expiry Date',
                credentialId: 'Credential ID',
                licenseNumber: 'License Number'
              }
            },
            education: 'Education',
            experience: 'Experience',
            hobbies: 'Hobbies and Interests',
            languages: 'Languages',
            militaryExperience: 'Military Experience',
            professionalAssociations: 'Professional Associations and Memberships',
            projects: 'Projects',
            references: 'References',
            researchAndPublications: 'Research and Publications',
            skills: 'Skills',
            summary: {
              empty: 'No summary available.',
              title: 'Summary'
            },
            trainingCoursesAndWorkshops: 'Training, Courses and Workshops',
            volunteerExperiences: 'Volunteer Experiences'
          },
          selectFile: 'Information extracted from file'
        }
      }
    },
    contacts: {
      creation: {
        title: 'New Contact',
        form: {
          title: 'Personal Data',
          subheader: 'Fields marked with * are required to add this lead'
        },
        alert: {
          title: 'Contacts',
          success: {
            body: 'Awesome! The contact was created successfully'
          }
        }
      }
    },
    drafts: {
      draft: 'Draft',
      confirmDialog: {
        save: {
          title: 'Save Draft',
          message:
            'Are you sure you want to save this {entity} as a draft? You can continue editing later.',
          confirmButtonText: 'Save Draft',
          cancelButtonText: 'Cancel'
        },
        saveOnCancel: {
          title: 'Save Draft',
          message: 'Do you want to save this {entity} as a draft? You can continue editing later.',
          confirmButtonText: 'Save Draft',
          cancelButtonText: 'Discard'
        },
        delete: {
          title: 'Delete Draft',
          message:
            'All the information registered for this {entity} will be lost. Are you sure you want to delete this draft?',
          confirmButtonText: 'Delete Draft',
          cancelButtonText: 'Cancel'
        },
        deleteAll: {
          title: 'Delete All Drafts',
          message:
            'All the information registered for these {entity} will be lost. Are you sure you want to delete all drafts?',
          confirmButtonText: 'Delete All',
          cancelButtonText: 'Cancel'
        }
      },
      alert: {
        success: {
          save: {
            title: 'Draft saved successfully',
            body: 'You can come back to edit it later'
          },
          delete: {
            title: 'Draft deleted successfully!'
          }
        },
        error: {
          migrateDraftsTitle: 'Error Migrating Drafts',
          migrateDrafts: '{count} legacy draft{plural} could not be migrated.'
        }
      },
      cardTitle: 'My Drafts',
      deleteAll: 'Delete All',
      button: {
        update: 'Update Draft',
        save: 'Save as Draft'
      },
      emptyState: {
        title: 'No Drafts to Show',
        subtitle: "You haven't saved any draft. Once you do, they'll appear here"
      },
      lastSaved: 'Draft saved at {updatedAt}',
      leaveForm: 'You have unsaved changes. Are you sure you want to proceed?'
    },
    inventoryProfiles: {
      title: 'Profile',
      candidateProfile: {
        linkHiringAuthority: 'Link Candidate with Hiring Authority'
      },
      emptyStates: {
        fallBack: {
          title: 'No Results to Show',
          subtitle: `We couldn't find any information to what you’re looking for. Please try another search`
        },
        activityLogs: {
          quickView: {
            title: "Nothing done yet! Let's register your activity",
            subtitle: 'Once an Activity is added, it will be shown here'
          },
          profile: {
            title: "Nothing done yet! Let's register your activity",
            subtitle: 'Too add one, click the + Button'
          }
        },
        candidates: {
          quickView: {
            title: 'No Candidates to Show',
            subtitle: 'Once a Candidate is added, it will be shown here'
          },
          profile: {
            title: 'No Candidates to Show',
            subtitle:
              'To match this Job Order with a Candidate, click the “+ Match Candidate” button'
          }
        },
        companies: {
          quickView: {
            title: 'No linked Companies',
            subtitle: 'Once a Company is added, it will be shown here'
          },
          profile: {
            title: 'No linked Companies',
            subtitle: 'To link a Company, click on the button'
          }
        },
        feeAgreements: {
          quickView: {
            title: 'No Fee Agreements to Show',
            subtitle: 'Once a Fee Agreements is added, it will be shown here'
          },
          profiles: {
            title: 'No Fee Agreements to Show',
            subtitle: 'To create a Fee Agreement, click the “+ New Fee Agreement” button'
          }
        },
        files: {
          title: 'No Files to Show',
          subtitle: 'To add an attachment, click the “Upload File” button'
        },
        hiringAuthorities: {
          quickView: {
            title: 'No Hiring Authorities to Show',
            subtitle: 'Once a Hiring Authority is assigned, it will be shown here'
          },
          profile: {
            title: 'No Hiring Authorities to Show',
            subtitle: 'To assign a Hiring Authority, click the “+ New Job Order” button.'
          }
        },
        joborders: {
          quickView: {
            title: 'No Job Orders to Show',
            subtitle: 'Once a Job Order is added, it will be shown here.'
          },
          profile: {
            title: 'No Job Orders to Show',
            subtitle: 'To add a Job Order, click the “+ New Job Order” button.'
          }
        },
        referenceCheck: {
          title: 'No References to Show',
          subtitle: 'To add a Reference, click the “+ New Reference” button.'
        },
        notes: {
          quickView: {
            title: 'No Notes to Show',
            subtitle: 'Once a Note is added, it will be shown here'
          },
          profile: {
            title: 'No Notes to Show',
            subtitle: 'To leave a note, click the “+ New Note” button'
          }
        },
        placements: {
          quickView: {
            title: 'No Placements to Show',
            subtitle: 'Once a Placement is created, it will be shown here. '
          },
          profiles: {
            title: 'No Placements to Show',
            subtitle: 'Once a Placement is created, it will be shown here'
          }
        },
        sendouts: {
          quickView: {
            title: 'No Sendouts to Show',
            subtitle: 'Once a Sendout is added, it will be shown here.'
          },
          profiles: {
            title: 'No Sendouts to Show',
            subtitle: 'To Create a Sendout the Job Order needs to be assigned to you'
          }
        },
        actionPlan: {
          title: 'No Actions Added',
          subtitle:
            'Organize your desk and boost your daily productivity. To add an action, click the + New Action button.'
        },
        sales: {
          title: 'No Sales'
        }
      },
      common: {
        editProfile: 'Edit Information',
        candidateAddition: 'Add as Candidate',
        haAddition: 'Add as Hiring Authority',
        optOut: {
          isOptOut: 'Opt out',
          creation: 'Opt out since'
        },
        restriction: {
          menuItem: 'Request {restriction}',
          doNotContact: 'Do Not Contact',
          doNotEngage: 'Do Not Engage',
          requestInProgress: 'Request In Progress',
          drawer: {
            title: 'Request "{restriction}" Status',
            doNotContactBody: `The "Do Not Contact" status permanently blocks all outreach, including bulk emails, SMS, calls, and campaigns. Only request this status when the contact has explicitly asked to stop being reached.
            \nProvide a reason and paste a screenshot (such as an email or text request) as evidence so your request can be reviewed.`,
            doNotEngageBody: `The “Do Not Engage” status flags the contact with a documented risk, such as a financial issue, a conduct concern, or another negative interaction. It doesn't block communication, but alerts your team that engagement should be handled carefully. Only request this status when there is a clear and valid reason.
            \nSelect the reason, provide a brief explanation, and upload a screenshot (such as an email, message, or document) as evidence so others can understand the situation and your request can be reviewed.`,
            send: 'Send Request',
            subStatusLabel: 'Reason to {restriction}',
            error: {
              title: '{restriction} Request Failed'
            }
          }
        },
        emailValidationStatus: {
          valid: 'Valid',
          invalid: 'Invalid',
          risky: 'Risky',
          alert: {
            learnMoreBtn: 'Learn More',
            riskyCopy: {
              primaryText:
                "The existence of this email address cannot be verified. To confirm its validity, contact the recipient individually. Bulk sending to risky email addresses can damage your sender's reputation and make it more difficult to deliver your emails in the future. If a large number of your emails bounce, this can also occur. It is best to send emails to risky addresses individually.",
              secondaryText:
                'Email addresses are validated when receiving an email response from them. If you spoke with the contact and confirmed the email, ask them to respond to your last email.'
            },
            validationDateLabel: 'Validation Date: '
          },
          table: {
            tooltip: {
              invalid: "This email is invalid and can't be mailed",
              risky: 'This email is risky and mail it could affect deliverability'
            }
          }
        },
        referenceRelease: 'Reference Release',
        linkEntitiesTitle: `{entity} Assigned Successfully`,
        linkEntitiesDescription: `Assigned to {profileName}`,
        summaryLabelDate: 'Added Date',
        summaryLabelCreationBy: 'Added By',
        recruiterLabel: 'Recruiter',
        searchEntities: 'Search for an existing {entity} or',
        newEntity: 'You are now creating a new {entity} but you can',
        selectEntityButton: 'Select an existing {entity}',
        selectEntitiesButton: 'Select an existing {entity} or {additionalEntity}',
        assignRecruiter: 'Assign to Recruiter',
        startMarketing: 'Start Marketing',
        startRecruiting: 'Start Recruiting',
        editionModes: {
          update: 'Updated',
          add: 'Added'
        },
        edition: `{inventoryItem} updated successfully`,
        reassignRecruiterDrawer: {
          mainCoachAssing: 'Assign this item also to:',
          coach: 'Assign this item to:',
          recruiterAssign: 'Additional recruiter',
          defaultCollaborationRequestTitle: 'Recruiter Assignments',
          collaborationRequestTitle: 'Collaboration Request',
          collaborationRequestMarketingTitle: 'Start Marketing',
          collaborationRequestRecruitingTitle: 'Start Recruiting'
        },
        keywords: {
          title: 'Keywords',
          placeholder: 'Select keywords'
        }
      },
      sections: {
        overview: {
          activityButtonLabel: 'See all Activities',
          noteButtonLabel: 'See all Notes',
          candidateOverview: {
            general: 'General Information',
            nickName: 'NickName',
            title: 'Title',
            industry: 'Industry · Specialty',
            subspecialty: 'Subspecialty',
            zipCode: 'Zip Code',
            source: 'Source',
            linkedIn: 'LinkedIn Profile',
            phone: 'Phone - Ext',
            otherPhone: 'Other Phone'
          }
        },
        tabs: {
          note: {
            title: 'Delete note',
            message: 'Are you sure you want to delete this Note?',
            deletedMessage: 'Note deleted successfully'
          },
          activityNote: {
            drawerTitle: 'Activity',
            creationAction: '{section} {action} Successfully',
            activityActionText: 'New Activity',
            noteActionText: 'New Note',
            message: 'Are you sure you want to delete this Activity?',
            deletedActivity: 'Activity deleted successfully',
            deleteAction: {
              title: 'Delete Activity'
            },
            form: {
              validation: {
                activityOutcome: 'Outcome is required when comments are provided',
                activityOutcomeComments: 'Cannot add comments without selecting an outcome',
                title: 'The title is required'
              },
              label: {
                createdBy: 'Created by',
                createdDate: 'Creation date'
              }
            },
            drawer: {
              backAction: 'Back to Contact',
              title: {
                activity: 'Activity',
                note: 'Note'
              },
              alert:
                "Once the activity is added, it can't be edited or deleted. Are you sure you want to add this activity?",
              confirmButton: 'Save New Activity'
            }
          },
          employees: {
            additionButton: 'Add Employee',
            search: 'Search contact by name or email',
            failedSearch: 'No Contacts found'
          },
          hiringAuthorities: {
            dialogTitle: 'Remove Hiring Authority',
            dialogDescription: 'Are you sure you want to remove {hiringAuthority} from {company}',
            additionButton: 'Add Hiring Authority',
            delete: {
              title: 'Hiring Authority Removed Successfully'
            },
            update: `Hiring Authority {hiringAuthorityEditionMode} Successfully`,
            editTitle: 'Edit Hiring Authority',
            addTitle: 'Add Hiring Authority to this Company'
          },
          changeLogs: {
            sectionName: 'Changelog',
            drawer: {
              changes: 'Changes',
              update: 'Updates',
              empty: 'No changes detected.'
            }
          },
          referenceCheck: {
            title: "{candidateName}'s Reference Check",
            sectionName: 'Reference Check',
            infoText: 'At least 2 references are required to create a Placement',
            drawer: {
              added: 'Reference Check Added Successfully',
              updated: 'Reference Check Updated Successfully'
            },
            deleted: 'Reference Check Deleted Successfully',
            confirmDelete: 'Are you sure you want to delete this Reference Check?',
            aiSummary: {
              sectionTitle: 'AI Summary',
              failed: 'Reference Check AI Summary Failed',
              actionButton: 'Summarize with AI',
              actionButtonLoading: 'Summarizing...'
            }
          },
          jobOrders: {
            actions: {
              assign: 'Assign Job Order',
              create: 'Create Job Order',
              remove: 'Remove Job Order'
            },
            drawer: {
              placeholder: 'Search a Job order by Position, Job Function, or Company'
            }
          },
          sendouts: {
            delete: `Sendout can't be deleted `
          },
          placements: {
            action: 'Create Placement'
          },
          organize: {
            title: 'Organize Tabs',
            headerText: 'Customize your layout by dragging the tabs:'
          },
          sales: {
            talbeColumns: {
              amount: 'Amount',
              candidate: 'Candidate',
              createdOn: 'Created on',
              documentNumber: 'Document Number',
              dueDate: 'Due Date',
              memo: 'Memo',
              notes: 'Notes',
              onCollections: 'On Collections',
              openBillingText: 'Open Billing Text',
              status: 'Status',
              transactionDate: 'Transaction Date'
            }
          },
          actionPlan: {
            tabLabel: 'Action Plan'
          },
          dataSheet: {
            tabLabel: 'Data Sheet Preview',
            emptyState: 'Data is not available for this Candidate yet.',
            period: {
              present: 'Present'
            },
            sections: {
              achievements: 'Achievements',
              education: {
                title: 'Education',
                degreeAndMajor: `{degree} in {major}`
              },
              experience: {
                title: 'Experience',
                description: `{dutiesAndResponsibilities}\n{accomplishments}`
              },
              experienceSummary: 'Experience Summary',
              licensesAndCertifications: 'Licenses and Certifications',
              skills: 'Skills'
            }
          }
        },
        candidates: {
          matchCandidateDrawer: 'Match Candidate',
          referenceReleseSend: 'Send',
          referenceReleaseResend: 'Send Again',
          referenceReleaseDrawerTitle: 'Reference Release Email',
          referenceReleaseTitle: 'Send Reference Release Email',
          referenceReleaseMessage: 'Are you sure you want to send this email to {email}?',
          candidateSheetEdit: 'The write up was updated successfully',
          candidateEdit: 'The candidate was updated successfully',
          confirmJobOrderDeletetion: 'Are you sure you want to remove this Job Order from',
          onJobOrderDeleteSuccess: 'Removed from',
          drawerPlaceholder: 'Search a Candidate by Name, Title or Job Function',
          duplicatedCandidateDialog: {
            title: 'Duplicated Email',
            message: `You're having the same email address for both profiles <b>{email}</b>. We recommend setting up a different one for better bulk sends. Are you sure you want to save this Hiring Authority with the same email address?`
          },
          duplicatedEmailHint: 'We recommend to set a different email address.',
          linkCandidateDialog: {
            title: 'Link Profiles',
            message: `Are you sure you want to link these Candidate and Hiring Authority profiles for <b>{hiringName}?</b>`
          },
          unlinkHiringDialog: {
            title: 'Unlink Profiles',
            message: `Are you sure you want to unlink the Candidate and Hiring Authority profiles for <b>{hiringName}?</b>`
          }
        },
        jobOrders: {
          updateProfile: 'Job Order Updated Successfully',
          notAvailableStrings: {
            drawerTitle: 'New Sendout',
            title: 'Company not signed yet',
            description: 'To create a sendout, this company must be signed',
            buttonTitle: 'Sign Company'
          },
          deleteAlert: {
            severity: 'success',
            title: 'Awesome',
            body: 'The Job Order was removed from this Candidate successfully'
          },
          duplicateDialog: {
            confirmButtonText: 'Duplicate',
            message:
              'Are you sure you want to duplicate this Job Order? You can modify it later if needed.',
            title: 'Duplicate Job Order'
          },
          successDuplication: 'Job Order Created Successfully'
        },
        companies: {
          companyType: 'Confirm Company Type',
          updateType: 'Update Company Type'
        }
      },
      quickView: {
        initialText: 'Go to Profile',
        viewProfile: 'View Profile'
      },
      accountability: {
        action: 'Request Inventory',
        drawer: {
          title: 'Request Inventory',
          successButton: 'Request',
          textBoxLabel: 'Reasons and Additional Instructions',
          textBoxPlaceholder: 'Describe your request',
          content: {
            firstLine:
              'This action will create a ticket that will be reviewed by the appropiate team.',
            secondLine:
              'A confirmation email will be sent to you once this request is submitted, as well as a request completion email once your request is either approved or declined.'
          },
          success: {
            title: 'Inventory Request Submitted',
            body: 'You will receive an email confirmation shortly.'
          }
        }
      }
    },
    recruiterProfile: {
      cashInTitle: 'Career Cash-In',
      cashInYearToDate: 'Cash-In YTD',
      channelPartnerTotal: 'Production',
      channelPartner: 'Channel Partner',
      emptyChannelPartner: 'Join the Channel Partner Program to start earning',
      fallOffsYearToDate: 'Fall Offs YTD',
      monthlyFallOffs: 'Fall Offs',
      placementCardPlural: 'Placements',
      placementCardSingular: 'Placement',
      placementsYearToDate: 'Placements YTD',
      productionYearToDate: 'Production YTD',
      statsCashIn: 'Top 50 YTD Chash-In',
      statsRegion: 'Position by Region',
      statsSendouts: 'Weekly Sendouts Stats',
      statsTeam: `Position by team {team}`,
      statsWeek: 'Position in current Week',
      noteAddition: 'Note Added Successfully',
      feedbackAction: 'Feedback Notes',
      emptyStateNotes: 'No Notes to Show',
      cashInPositon: 'Work hard, seize opportunities, and push your limits to reach the Top 50',
      titleNameTextBox: 'title',
      noteTitleValidation: 'The title is required',
      milestones: {
        searchConsultant: {
          searchConsultant: {
            title: 'Search Consultant'
          },
          searchConsultantTitle: 'Search Consultant',
          initial: 'Work your way trough to become a Sr. Search Consultant',
          successSenior: 'Congrats! You have achieved the Sr. Search Consultant position',
          initialSenior: 'Work your way through become a Director',
          successDirector: 'Congrats! You have achieved the Director Position',
          initialSeniorDirector: 'Work your way through become a Sr. Director',
          successSeniorDirector:
            'Congrats on becoming a Sr. Director! Your hard work and dedication have set you apart'
        },
        alphaPac: {
          progress: 'Embrace the challenge and work hard to unlock the Alpha Pac Trip',
          success: "Pack your bags! You're ready for the next Alpha Pac Trip"
        }
      }
    },
    hiringAuthorities: {
      removeCompanyTitle: 'Remove Company',
      successCompanyRemoved: 'Company Removed Successfully',
      messages: {
        confirmRemoveCompany:
          'Are you sure you want to remove the relationship between {company} and {hiringAuthority}?',
        successRemoveCompany: '{company} removed from {hiringAuthority}',
        confirmMainCompany:
          'Are you sure you want to assign this Company as the main one for this H.A.?',
        successMainCompany: 'The Company was marked as main successfully'
      },
      form: {
        newHiringAuthority: 'You are now creating a new Hiring Authority but you can',
        existingHiringAuthority: 'Search for an existing Hiring Authority or',
        addedCompany: 'Select for an existing H.A. from Company',
        addedContacts: 'Select an existing Contact or Hiring Authority',
        addedToCompany:
          'This Hiring Authority will be added to the Company and to the Job Order at the same time.'
      }
    },
    email: {
      aboutSignature: 'Your official gpac email signature will be added automatically.'
    },
    pil: {
      title: 'Industries',
      secondTitle: 'Industry Details',
      instructions: 'Click on any Industry to view its details',
      description: '{pil} Description',
      emptyDescription: '(without description)',

      functionalTitles: {
        instructions: 'Click on any Specialty to view its details',
        title: 'Job Functions',
        empty: "This specialty doesn't have job functions."
      }
    },
    teams: {
      title: 'Teams',
      instructions: 'Select any Specialty to preview the teams working on it.'
    },
    companies: {
      plural: 'Companies',
      associations: {
        main: 'Show only Main/HeadQuarters',
        branches: 'Show only Branches/Locations'
      },
      creation: {
        title: 'New Company',
        mainSection: 'Contact Data',
        hiringAuthorities: {
          title: 'Hiring Authorities',
          helper:
            "You can add the Hiring Authority later, but remember that it'll be needed to create a Job Order",
          add: 'Add Hiring Authority'
        },
        fields: {
          name: 'Name *',
          legalName: 'Legal Name',
          specialty: 'Specialties *',
          subspecialty: 'Subspecialties',
          phone: {
            label: 'Phone *',
            placeholder: '(999)-999-9999'
          },
          ext: {
            label: 'Ext.',
            placeholder: '999'
          },
          email: 'Email',
          accountsPayableEmail: 'Accounts Payable Email',
          address: 'Address *',
          website: 'Website',
          linkedinUrl: 'LinkedIn URL',
          type: 'Type'
        },
        success: 'Awesome! The Company was created successfully',
        duplicateHiringAuthorities: {
          warning:
            'There are duplicate hiring authorities selected for this company. Remove duplicate information to be able to save'
        },
        similarCompanies: {
          title: 'Similar Companies Found',
          subtitle: "Please make sure you're not adding a duplicate.",
          alert: "We found similar Companies that match the information you're registering."
        },
        targetCompany: {
          label: 'Is it a Target Company?',
          helperText:
            'A Priority Target is a company desired to be client for gpac which means it should be worked with high priority.',
          options: {
            showTargetCompanies: 'Show target companies only',
            excludeTargetCompanies: 'Exclude target companies'
          }
        },
        exactMatch: {
          title: 'Companies Already Registered',
          subtitle: "These are the exact matches of the information you're registering.",
          alert:
            "{name} is already in FortPac and won't be saved to avoid duplicates. If this is an error, please contact Fortpac Support"
        },
        associated: {
          title: 'Associated Companies',
          subheader: 'Establish relationships to have a better Company structure',
          relationship: {
            parent: 'Parent',
            sibling: 'Siblings',
            child: 'Children'
          },
          warnings: {
            mixedCompanies: {
              childParent: 'A Child Company is also selected as Parent Company.',
              childSibling: 'A Child Company is also selected as Sibling Company.',
              siblingParent: 'A Sibling Company is also selected as Parent Company.',
              edit: 'Edit the information to be able to save'
            }
          },
          tab: {
            alert: {
              add: 'added',
              remove: 'removed',
              addTitle: 'Success',
              body: '{association} {entity} {actionText} successfully'
            }
          },
          dialog: {
            removeTitle: 'Remove Association',
            removeMessage:
              'This will affect some associations of <b>{companyName}</b> with other companies. <br> Are you sure you want to remove this {associationType} Company?',
            confirmButtonText: 'Remove',
            cancelButtonText: 'Keep'
          },
          form: {
            parent: {
              description: 'Select the Parent Company for',
              placeholder: 'Search by Company Name or Location'
            },
            childSibling: {
              tranferList: {
                companiesSelected: 'Companies Selected',
                results: 'Results'
              },
              disabledReasons: {
                cantBeSelected: "can't be selected because",
                hasAlreadyParent: 'has already a Parent',
                isASister: "it's the current Sibling of this Company",
                isCurrentParent: "it's the current Parent of this Company"
              }
            }
          },
          overview: {
            name: 'Name',
            industry: 'Industry: Specialty',
            location: 'Country: State',
            ha: 'Hiring Authority'
          }
        }
      },
      typeHelper:
        'If your company is already a vendor or client, upload your agreement and ask Ops to mark it accordingly'
    },
    inventory: {
      assignment: {
        title: 'Assign to a recruiter',
        helper: 'Choose a recruiter to assign this item to',
        placeholder: 'Recruiters in your team'
      },
      quickEntry: {
        actionButton: 'Quick Entry',
        validations: {
          required: 'This field is required',
          invalidEmail: 'Email must be valid'
        },
        fileCard: {
          removeFile: 'Remove file'
        },
        modal: {
          emptyState: 'No Quick Entry Type Found.',
          error: 'Something went wrong getting the Quick Entry type. Please try again.',
          title: 'Quick Entry',
          subtitle: 'What do you want to capture?'
        },
        drawers: {
          candidate: {
            title: 'Candidate Quick Entry',
            fields: {
              name: 'Candidate Name',
              email: 'Candidate Email',
              notes: 'Notes'
            },
            notesTemplate:
              'Establishing Urgency\n\nCandidate Background\n\nWork Preferences\n\nProfessional Insights\n\nQualification',
            uploads: {
              resume: 'Resume',
              candidateDataSheet: 'Candidate Data Sheet',
              handwrittenNotes: 'Handwritten Notes'
            },
            actions: {
              cancel: 'Cancel',
              saveEntry: 'Save Entry',
              continueToDataSheet: 'Continue to Candidate Data Sheet'
            },
            alert: {
              error: 'There was an error saving the Candidate Quick Entry. Please try again.',
              success: 'The Candidate Quick Entry draft was {action} successfully'
            },
            continueToDataSheetDialog: {
              actionButton: 'Got it',
              message:
                "You'll receive an email in a couple minutes to review and complete the draft created.",
              title: 'Parsing Quick Entry'
            },
            emptyState: {
              title: 'Candidate Quick Entry not found.'
            }
          },
          jobOrder: {
            title: 'Job Order Quick Entry',
            fields: {
              position: 'Position',
              hiringAuthorityName: 'Hiring Authority Name',
              companyName: 'Company Name',
              notes: 'Notes'
            },
            notesTemplate: `1 · ESTABLISHING URGENCY
Why the company is looking and for how long, when they need someone in place, what they’ve done to cover it and the results, how the work is getting done now, and the consequences of leaving it open.

2 · IDEAL CANDIDATE & DUTIES
The ideal candidate required skills, certifications and the previous person’s background — and the role itself: the duties they must fulfill, work location, any territory it covers, and the company’s biggest competitors.

3 · COMPENSATION & BENEFITS
Salary type and range, commissions and bonuses, realistic first-year total, benefits and company vehicle, and where the role could lead.

4 · HIRING PROCESS
The steps and people in their hiring process and who decides, companies they’d hire from or avoid, anyone specific to reach out to, and their interview availability.

5 · SELLING POINTS & QUALIFICATION
What makes the opportunity and company attractive (and any other openings), plus your read — job order type and status. A true search assignment has an urgent need, willingness to pay the fee, realistic expectations, mutual respect, and isn’t being worked on their own.`,
            uploads: {
              resume: 'Resume',
              assignmentDataSheet: 'Assignment Data Sheet',
              handwrittenNotes: 'Handwritten Notes'
            },
            actions: {
              cancel: 'Cancel',
              saveEntry: 'Save Entry',
              continueToDataSheet: 'Continue to Assignment Data Sheet'
            }
          },
          warningCloseDialog: {
            title: 'Closing Quick Entry',
            message:
              'To avoid losing your work, please save your Quick Entry before exiting. Are you sure you want to close the Quick Entry Form?',
            actions: {
              discardAndExit: 'Discard & Exit',
              cancel: 'Back to Quick Entry'
            }
          }
        },
        table: {
          title: 'Quick Entries',
          emptyState: {
            title: 'No Quick Entries to Show',
            subtitle: 'Once a Quick Entry is added, it will be shown here.'
          },
          deleteDialog: {
            title: 'Deleting Quick Entry',
            message: 'Are you sure you want to delete the {title} quick entry?'
          },
          columns: {
            createdOn: 'Created on',
            email: 'Email',
            lastUpdatedOn: 'Last Updated on',
            name: 'Name',
            position: 'Position',
            preview: 'Preview',
            status: 'Status'
          },
          deleteAlert: {
            error: 'Error deleting {entity} Quick Entry',
            success: '{entity} Quick Entry deleted successfully'
          }
        },
        statuses: {
          draft: 'Draft',
          inProgress: 'In Progress'
        }
      },
      phoneNumbers: {
        component: {
          title: 'Contact Phone Numbers',
          defaultRadio: 'Set as a Default Phone',
          removeTooltip: 'Remove Phone',
          addNewPhoneBtn: 'Add New Phone'
        }
      },
      jobOrders: {
        create: {
          title: 'Job Order',
          newJobOrder: {
            title: 'New Job Order'
          },
          assignmentSheet: {
            new: {
              title: 'Assignment Data Sheet',
              subtitle:
                'It is required to fill the Assignment Data Sheet and choose the Job Order type in order to add it.',
              actions: {
                fillIn: 'Fill In'
              },
              warningFormFill: 'You must complete the assignment data sheet to add this Job Order'
            },
            old: {
              title: 'Write Up Assignment Sheet',
              subtitle:
                'It is required to fill the Write Up Assignment Sheet. The Assignment Sheet can be completed once the Job Order is created.',
              actions: {
                fillIn: 'Fill In'
              },
              warningFormFill:
                'You must complete the write up assignment sheet to add this Job Order'
            }
          },
          differentLocation: "Use a different location than the company's"
        },
        edit: {
          title: 'Edit Job Order'
        },
        editDataSheet: {
          contentPageTitle: 'Edit Assignment Data Sheet',
          title: 'Assignment Data Sheet',
          subheader: 'Fields marked with * are required',
          uiMessages: {
            error: 'Some fields have inconsistencies or are missing information',
            skillsError:
              'Please enter a valid value. Avoid using special characters; use commas to divide skills',
            complete: {
              success: 'Assignment Data Sheet Saved Successfully',
              error: 'There was an error saving the Assignment Data Sheet'
            }
          },
          decisionDialog: {
            title: 'You Have Unsaved Changes In The Assignment Data Sheet',
            message:
              'If you exit without saving, you may lose your progress. Do you want to save your changes before exiting?',
            buttons: {
              cancel: 'Cancel',
              exitWithoutSaving: 'Exit Without Saving',
              saveAndExit: 'Save And Exit'
            }
          }
        },
        profile: {
          dataSheetDescription:
            'To create a Placement, the Assignment Data Sheet must be filled.\nThe completed Assignment Data Sheet will be used for future job posting and bulking integration.',
          editButton: 'Edit Assignment Data Sheet',
          cards: {
            feeAgreement: {
              title: 'Fee Agreement Details'
            },
            position: {
              title: 'Position Details'
            },
            availableDateInterviews: {
              title: 'Available Interview Dates '
            },
            notes: {
              title: 'Additional Details'
            },
            dataSheet: {
              title: 'Details'
            },
            generalData: {
              title: 'General Data'
            },
            companyData: {
              title: 'Company Data'
            }
          },
          jobDescriptionTab: {
            emptyModel: 'No model information available.',
            emptyState: {
              subtitle:
                'No Job Descriptions available. Make sure a Job Description is uploaded in the attachments section.'
            },
            incompatibleStructure:
              'The provided file has not the structure of a valid Job Description',
            parseError: 'An error occurred while parsing the Job Description.',
            sections: {
              companySummary: {
                empty: 'No company information available',
                title: 'Company'
              },
              benefits: {
                benefits: 'Benefits',
                compensationRange: 'Compensation Range',
                title: 'Compensation and Benefits'
              },
              languageRequirements: 'Language Requirements',
              physicalRequirements: 'Physical Requirements',
              preferredQualifications: 'Preferred Qualifications',
              reportingStructure: 'Reporting Structure',
              requiredQualifications: 'Required Qualifications',
              responsabilities: 'Key Responsibilities',
              skills: 'Skills',
              summary: {
                fields: {
                  aboutRole: 'About the Role',
                  employmentType: 'Employment Type',
                  location: 'Location',
                  schedule: 'Schedule',
                  travel: 'Travel',
                  workDays: 'Work Days'
                }
              }
            },
            selectFile: 'Information extracted from file'
          }
        }
      },
      urgencyVerification: {
        fields: {
          verified: 'Urgency reviewed and verified. *',
          actions: 'Actions Taken *',
          details: 'Details'
        },
        title: 'Verify Urgency',
        subtitle: 'Urgency Verification',
        description:
          'This will validate the urgency state of the item and it will be shown as Hot Inventory',
        results: {
          candidate: 'This Candidate has been verified',
          jobOrder: 'This Job Order has been verified'
        }
      },
      matchMaking: {
        actionButtons: {
          matchEntityType: 'Match {entityType}',
          matchCandidates: 'Match Candidates',
          matchJobOrders: 'Match Job Orders',
          onProgressText: 'Starting...',
          refresh: 'Refresh List'
        },
        alerts: {
          error: {
            body: 'Failed to start the Match',
            title: 'Error Starting Match'
          }
        },
        matchMakingNotStarted: {
          title: 'Match Making Not Started',
          subtitle: 'Click the Match {entityType} button to run a search.'
        },
        emptyState: {
          noMatchMakingConfigured: 'No match making is configured',
          title: 'No Matches Found',
          subtitle:
            'No records meet the criteria for this profile. To run a new search, click the Match button.'
        },
        error: {
          title: 'Error while Finding Matches',
          subtitle:
            'Click the Match button to try again. If the problem persists, contact FortPac Support.'
        },
        labels: {
          info: 'This is an automated list constantly updated by AI matching candidates with the Job Order details.',
          inventoryToMatch: 'Inventory to Match',
          lastBulkedOn: 'Last Bulked on',
          tableFooterAi:
            'An Excellent Score means the Skills, Experience, Education, Certifications/Licenses and Location of the Candidate matches the required Qualifications, Responsibilities, Skills and Location from the Job Description.',
          tableFooterBasic:
            'An Excellent score means the Job Function, Industry, Title and Location of the Candidate match perfectly to the Job Order counterpart. The score gets lower while the location is further or the Job Functions/Titles differ.'
        },
        matchTypes: {
          default: 'Basic',
          ai: 'AI Match'
        },
        title: 'Match Making'
      },
      shared: {
        listing: {
          addActivities: 'Add Activities',
          addKeywords: 'Add Keywords',
          addNotes: 'Add Notes',
          multipleActivityCreation: {
            total: '{total} {entity} selected to add {activity}.',
            sections: {
              activities: 'Activities',
              keywords: 'Keywords',
              notes: 'Notes'
            }
          }
        }
      }
    },
    dashboard: {
      shared: {
        gpac: 'gpac',
        regional: 'regional',
        scope1: 'gpac All',
        scope2: 'All Coaches',
        region: 'Region',
        team: 'Team'
      },
      emptyMessage: 'There is no data with the selected filters',
      toolsUsage: {
        title: 'Tools Usage',
        updateInfo: {
          title: 'Metrics update time is varied:',
          thirtyMinutesUpdate:
            '{updatedFields} update every 30 minutes. Last updated on {date} at <b>{time} (CST)</b>',
          inMails:
            'LinkedIn InMails data has a 24-hour delay, updating daily at 1:30 PM. LinkedIn may take up to 48 hours to sync all accounts. Last updated on {date} at <b>{time} (CST)</b>',
          livePosts:
            'Live Posts have a 24 hour delay, updating every day at 7:30 AM. Last updated on {date} at <b>{time} (CST)</b>'
        },
        downloadReport: 'Download Report',
        successDownload: 'File Downloaded Successfully',
        errorDownload: 'Oops! File Error'
      },
      summaryTable: {
        actions: {
          downloadAll: 'Download Full Individual Stats',
          downloadCsv: 'Download Whole Overview'
        }
      }
    },
    fileManager: {
      deleteFile: {
        title: 'Delete File',
        message: 'Are you sure you want to delete "{fileName}"?',
        successTitle: 'File Deleted Successfully',
        successMessage: '"{fileName}" was deleted successfully'
      },
      dropzone: {
        disabled: 'This section already has {maxFiles} files uploaded',
        enabled: 'Drop your files here or click to browse (Max. {maxFileSize} per file)',
        uploading: 'Uploading file... (Size: {fileSize})'
      },
      duplicateFile: {
        title: 'Existing File',
        message: '"{fileName}" is already uploaded'
      },
      extFile: {
        title: 'Invalid File Extension',
        message: 'Only these file types are allowed: {allowedExtensions}'
      },
      fileItem: {
        menuItemsTitles: {
          delete: 'Delete',
          download: 'Download',
          view: 'View',
          moveTo: 'Move to'
        }
      },
      fileName: {
        title: 'Invalid File Name',
        message: `Ensure the file name doesn't have special characters such as /\\ ^ <> ~ "[ ] : + = ÷ ; : , ' ? * @ | $ # %`
      },
      moveFileConfirm: {
        title: 'Move to',
        message: 'File "{fileName}"'
      },
      newProfile: {
        sectionTitle: 'Attachments',
        sectionSubtitle:
          'You can upload files later but we suggest you upload the {categorySuggested} file at least'
      },
      sizeFile: {
        title: 'File Size Limit Exceeded',
        message:
          "{fileName} is larger than {maxFileSize} and can't be added, please select a smaller file"
      },
      validQuantity: {
        title: 'File Limit Reached',
        message: 'This section has already reached the file limit',
        body: 'You can only upload {maxFiles} files in this section'
      },
      error: {
        title: 'Attachments Error'
      }
    },
    leaderboard: {
      pageTitle: 'Leaderboard',
      noDailyLeaders: {
        title: 'No leaders yet',
        subtitle: 'Hurry! Send three or more Sendouts today to stay on top of the leaderboard.'
      },
      noWeeklyLeaders: {
        title: 'No Leaders yet',
        subtitle:
          'Go further and send five or more Sendouts on this week to climb up on the leaderboard!'
      }
    },
    notifications: {
      denied: `Notifications blocked. You may be missing important alerts. Allow FortPac notifications in your browser settings. Please contact Fortpac Support.`,
      granted: `Notifications are currently off. You may miss important alerts. To receive notifications,`,
      error: {
        title: 'Notifications'
      }
    },
    collections: {
      title: 'AR & Collections',
      columns: {
        id: 'Internal ID',
        invoiceNo: 'Invoice #',
        placementId: 'Placement ID',
        phone: 'HQ Phone',
        commitToPay: 'Comm to Pay',
        commitDate: 'Comm Date',
        commitAmount: 'Amount',
        memo: 'Memo',
        dueDate: 'Due Date',
        total: 'Total',
        remaining: 'Remaining',
        company: 'Company',
        ha: 'Hiring Authority',
        candidate: 'Candidate',
        recruiter: 'Recruiter',
        coach: 'Team on Invoice',
        currentCoach: 'Team',
        position: 'Position',
        notes: 'Notes',
        assignedForCollections: 'Assigned For Collections'
      },
      fields: {
        committedToPay: 'Committed to Pay?',
        commitDate: 'Commit Date',
        commitAmount: 'Commit Amount',
        notes: 'Collection Notes'
      },
      ctas: {
        view: 'View Placement'
      },
      messages: {
        recordUpdated: 'Invoice updated successfully',
        recordNotUpdated: 'Invoice not updated as expected. Please contact Fortpac Support'
      },
      filters: {
        terms: 'Show Invoices of Termed and Former Regional Directors',
        searchInSplit: 'Search also in Candidate side of the split',
        status: 'Status',
        next2weeks: 'Next 2 Weeks',
        lastMonthsAndTwoWeeks: 'Last 12 Months + 2 Weeks',
        pastDueDate: 'days past due date'
      }
    },
    commandCenter: {
      title: 'Command Center',
      healthDistributionDrawers: {
        behind: {
          title: 'Falling Behind Recruiters'
        },
        atRisk: {
          title: 'At Risk Recruiters'
        },
        headcount: {
          title: 'All recruiters'
        },
        inTraining: {
          title: 'In Training Recruiters'
        },
        onTrack: {
          title: 'On Track Recruiters'
        },
        under3Months: {
          title: 'Under 3 Months Recruiters'
        }
      },
      drawers: {
        calls: {
          title: 'Calls'
        },
        candidates: {
          title: 'Candidates'
        },
        companies: {
          title: 'Companies'
        },
        fallOffs: {
          title: 'Fall Offs'
        },
        jobOrders: {
          title: 'Job Orders'
        },
        hiringAuthorities: {
          title: 'Hiring Authorities'
        },
        names: {
          title: 'Contacts'
        },
        placements: {
          title: 'Placements'
        },
        relatedCompanies: {
          title: 'Companies related to'
        },
        relatedContacts: {
          title: 'Contacts related to'
        },
        sendouts: {
          title: 'Sendouts'
        },
        sendovers: {
          title: 'Sendovers'
        },
        sentAgreements: {
          title: 'Sent Agreements'
        },
        signedAgreements: {
          title: 'Signed Agreements'
        }
      },
      healthDistributionInfo: {
        healthStatus: 'Health Status',
        atRisk: {
          label: 'At Risk',
          value:
            'Draw balance is higher than 1.5 Months and Outstanding Production + Cash in is lower than Draw Balance'
        },
        behind: {
          label: 'Behind',
          value:
            'Draw balance is lower than 1.5 Months and Outstanding Production + Cash in is lower than Draw Balance'
        },
        onTrack: {
          label: 'On Track',
          value: 'Outstanding Production + Cash In is higher than Draw Balance'
        }
      },
      widget: {
        errorTemplate: {
          action: 'Try again',
          subtitle: 'Please try again. If the problem persists, contact FortPac Support.',
          title: `Couldn't Retrieve Information`
        }
      },
      financeHealthLabels: {
        monthProduction: 'Month Production',
        monthCashIn: 'Month Cash In',
        ytdProduction: 'YTD Production',
        ytdCashIn: 'YTD Cash In',
        pdaYtd: 'PDA YTD',
        adjustedAverage: 'Adjusted %',
        trackingCashIn: 'Tracking Cash In',
        trackingProduction: 'Tracking Production'
      },
      metricsTitles: {
        adjustedAverage: 'Adjusted Avg',
        avgFee: 'Avg. Fee',
        bulks: 'Bulks',
        calls: 'Calls',
        candidates: {
          alpha: 'CA Alpha',
          cantHelp: `CA Can't Help`,
          overall: 'Candidates',
          poejo: 'CA POEJO',
          total: 'Total Candidates'
        },
        cashIn: 'Cash In',
        companies: {
          client: 'CO Client',
          notSigned: 'CO Not Signed',
          overall: 'Companies',
          signed: 'CO Signed',
          total: 'Total Companies'
        },
        drawBalance: 'Draw Balance',
        estimate: 'Estimate',
        fallOffRatePercent: 'Fall Off Rate',
        feeAgreementsSent: 'Sent Agreements',
        feeAgreementsSigned: 'Signed Agreements',
        hiringAuthorities: {
          client: 'HAs Client',
          notSigned: 'HAs Not Signed',
          overall: 'Hiring Authorities',
          signed: 'HAs Signed',
          total: 'Total HAs'
        },
        inMails: 'InMails',
        jobOrders: {
          cantHelp: `JO Can't Help`,
          overall: 'Job Orders',
          poejo: 'JO POEJO',
          searchAssignment: 'JO Search Assignment',
          total: 'Total Job Orders'
        },
        lastPlacementDate: 'Last Placement Date',
        lastSendoutDate: 'Last Sendout Date',
        month: 'Month',
        names: {
          candidateProspect: 'CA Prospects',
          hiringAuthorityProspect: 'HA Prospects',
          overall: 'Prospects',
          undefinedProspect: 'Undefined',
          total: 'Total Prospects'
        },
        notConnectedCalls: 'Not Connected Calls',
        outstandingBillings: 'Outstanding Billing',
        peopleReached: 'People Reached',
        perDeskAverage: 'PDA',
        phoneTime: 'Phone Time (Hrs)',
        placedRatio: 'SO/Placement',
        posts: 'Posts',
        production: 'Production',
        sendouts: 'Sendouts',
        sendovers: 'Sendovers',
        totalFallOffs: 'Fall Offs',
        totalPlacements: 'Placements',
        trackingCashIn: 'Tracking Cash In',
        trackingProduction: 'Tracking Prod.'
      },
      overallPerformance: {
        title: 'Overall Performance',
        columns: {
          avgDailyActivePosts: 'Avg Daily Active Posts',
          avgDailyInMails: 'Avg Daily InMails',
          avgFee: 'Avg Fee',
          avgFeePercentage: 'Avg Fee %',
          billings: 'Billings',
          bulks: 'Bulks',
          calls: 'Calls',
          candidates: 'Candidates',
          careerCashIn: 'Career Cash in',
          cashIn: 'Cash in',
          cashInYTD: 'Cash in YTD',
          channelPartner1: 'Channel P. 1',
          channelPartner2: 'Channel P. 2',
          companies: 'Companies',
          contacts: 'Contacts',
          countryCode: 'Country Code',
          currentActiveSendouts: 'Current Active Sendouts',
          currentDrawBalance: 'Current Draw Balance',
          currentHealthStatus: 'Current Health Status',
          currentOutstandingBillings: 'Current O. Billings',
          daysInStatus: 'Days in Status *',
          director: 'Director',
          estimates: 'Estimates',
          feeAgreementsSent: 'Fee Agreements Sent',
          hiringAuthorities: 'Hiring Authorities',
          inMails: 'InMails',
          lastDocBy: 'Last Doc By',
          lastDocDate: 'Last Doc Date',
          livePosts: 'Live Posts',
          location: 'Location',
          name: 'Name',
          newPosts: 'New Posts',
          notSignedCompaniesJobOrders: 'Not Signed Companies Job Orders',
          peopleReached: 'People Reached',
          phoneTime: 'Phone Time',
          placements: 'Placements',
          production: 'Production',
          productionYTD: 'Production YTD',
          recruitedBy: 'Recruited By',
          recruiterStatus: 'Recruiter Status',
          sendouts: 'Sendouts',
          sendovers: 'Sendovers',
          signedAgreements: 'Signed Agreements',
          signedCompaniesJobOrders: 'Signed Companies Job Orders',
          startDate: 'Start Date',
          supportActivityBy: 'Support Activity By',
          supportActivityDate: 'Support Activity Date',
          supportActivityType: 'Support Activity Type',
          supportTeam: 'Support Team',
          team: 'Team',
          tenure: 'Tenure',
          termDate: 'Term Date',
          trackingCashIn: 'Tracking Cash In',
          trackingProduction: 'Tracking Production'
        },
        filters: {
          financial: {
            avgFee: 'Avg. Fee',
            avgFeePercentage: 'Avg. Fee %',
            billings: 'Billings',
            careerCashIn: 'Career Cash in',
            cashIn: 'Cash In',
            drawBalance: 'Current Draw Balance',
            estimates: 'Estimates',
            outstandingBillings: 'Current Outstanding Billings',
            production: 'Production',
            trackingCashIn: 'Tracking Cash In',
            trackingProduction: 'Tracking Production',
            yearlyCashIn: 'Cash In YTD',
            yearlyProduction: 'Production YTD'
          },
          inventory: {
            candidates: 'Candidates',
            companies: 'Companies',
            contacts: 'Contacts',
            hiringAuthorities: 'Hiring Authorities',
            notSignedCompaniesJobOrders: 'Not Signed Companies Job Orders',
            signedCompaniesJobOrders: 'Signed Companies Job Orders'
          },
          metrics: {
            billingPeriodInMails: 'Billing Period InMails',
            bulks: 'Bulks',
            connectedCalls: 'Connected Calls',
            inMails: 'InMails',
            newLivePosts: 'New Posts',
            notConnectedCalls: 'Not Connected Calls',
            peopleReached: 'People Reached',
            phoneTime: 'Phone Time (Minutes)',
            posts: 'Avg Daily Active Posts',
            totalCalls: 'Total Calls'
          },
          productivity: {
            placements: 'Placements',
            sendouts: 'Sendouts',
            sendovers: 'Sendovers',
            signedAgreements: 'Signed Agreements',
            activeSendouts: 'Current Active Sendouts'
          },
          recruiters: {
            channelPartner: 'Channel Partner',
            country: 'Country',
            lastSupportActivity: 'Last Support Activity',
            lastSupportActivityDate: 'Last Support Activity Date'
          }
        },
        footer: {
          title: 'Daily & Weekly Activity Goals',
          infoLabel: '* Since tracked',
          metrics: {
            calls: {
              title: 'Calls',
              goals: 'Daily 60, Weekly 300'
            },
            phoneTime: {
              title: 'Phone Time',
              goals: 'Daily 2 hrs, Weekly 10 hrs'
            },
            bulks: {
              title: 'Bulks',
              goals: 'Daily 1, Weekly 5'
            },
            peopleReached: {
              title: 'People Reached',
              goals: 'Daily 100, Weekly 500'
            },
            inMails: {
              title: 'InMails',
              goals: 'Daily 20, Weekly 100'
            },
            posts: {
              title: 'Posts',
              goals: '100 live at all times with 5 new postings daily'
            }
          }
        }
      },
      dailyPerformance: {
        title: 'Daily Performance',
        overallPerformanceReport: {
          actionTitle: 'Refresh Stats',
          alert:
            'Calls, Bulks, and Posting cuts happen at <b>8:00 pm</b>. Activity after this time will be included in the next business day.',

          columns: {
            activeSendouts: 'Active Sendouts',
            activeSendovers: 'Active Sendovers',
            avgFeePercentageYTD: 'Avg Fee % YTD',
            avgFeeYTD: 'Avg Fee YTD',
            billingPeriodInMails: 'Billing Period InMails',
            bulks: 'Bulks',
            calls: 'Calls',
            candidates: 'Candidates',
            careerCashIn: 'Career Cash in',
            cashInYTD: 'Cash In YTD',
            channelPartner1: 'Channel Partner 1',
            channelPartner2: 'Channel Partner 2',
            companies: 'Companies',
            contacts: 'Contacts',
            countryCode: 'Country Code',
            currentHealthStatus: 'Current Health Status',
            currentOutstandingBillings: 'Current Outstanding Billings',
            currentWeekSendouts: 'Current Week Sendouts',
            currentWeekSendovers: 'Current Week Sendovers',
            director: 'Director',
            drawBalance: 'Current Draw Balance',
            hiringAuthorities: 'Hiring Authorities',
            inMails: 'InMails',
            lastDocBy: 'Last Doc By',
            lastDocDate: 'Last Doc Date',
            lastFiveWeeksSendouts: 'Last Five Weeks Sendouts',
            lastPlacement: 'Last Placement',
            lastWeekSendouts: 'Last Week Sendouts',
            location: 'Location',
            name: 'Name',
            newLivePosts: 'New Posts per Day',
            notConnectedCalls: 'Not Connected Calls',
            notSignedCompaniesJobOrders: 'Not Signed Companies Job Orders',
            peopleReached: 'People Reached',
            phoneTime: 'Phone Time',
            prevDayActivePosts: 'Prev. Day Active Posts',
            prevWeek2Sendouts: 'Prev. Week 2 Sendouts',
            prevWeek3Sendouts: 'Prev. Week 3 Sendouts',
            prevWeek4Sendouts: 'Prev. Week 4 Sendouts',
            productionYTD: 'Production YTD',
            recruitedBy: 'Recruited By',
            signedCompaniesJobOrders: 'Signed Companies Job Orders',
            soToPl: 'SO to PL',
            startDate: 'Start Date',
            supportActivityBy: 'Support Activity By',
            supportActivityDate: 'Support Activity Date',
            supportActivityType: 'Support Activity Type',
            supportTeam: 'Support Team',
            team: 'Team',
            totalCalls: 'Total Calls',
            trackingCashIn: 'Tracking Cash in',
            trackingProduction: 'Tracking Production'
          },
          filters: {
            financial: {
              avgFee: 'Avg. Fee YTD',
              avgFeePercentage: 'Avg. Fee % YTD',
              careerCashIn: 'Career Cash in',
              cashin: 'Cash In YTD',
              drawBalance: 'Current Draw Balance',
              outstandingBillings: 'Current Outstanding Billings',
              trackingCashIn: 'Tracking Cash In',
              trackingProduction: 'Tracking Production',
              yearlyProduction: 'Production YTD'
            },
            inventory: {
              candidates: 'Candidates',
              companies: 'Companies',
              contacts: 'Contacts',
              hiringAuthorities: 'Hiring Authorities',
              notSignedCompaniesJobOrders: 'Not Signed Companies Job Orders',
              signedCompaniesJobOrders: 'Signed Companies Job Orders'
            },
            metrics: {
              billingPeriodInMails: 'Billing Period InMails',
              bulks: 'Bulks',
              connectedCalls: 'Connected Calls',
              inMails: 'InMails',
              newLivePosts: 'New Posts per Day',
              notConnectedCalls: 'Not Connected Calls',
              peopleReached: 'People Reached',
              phoneTime: 'Phone Time (Minutes)',
              posts: 'Prev. Day Active Posts',
              totalCalls: 'Total Calls'
            },
            recruiters: {
              channelPartner: 'Channel Partner',
              country: 'Country',
              lastSupportActivity: 'Last Support Activity',
              lastSupportActivityDate: 'Last Support Activity Date'
            },
            sendouts: {
              active: 'Active Sendouts',
              activeSendovers: 'Active Sendovers',
              currentWeek: 'Current Week Sendouts',
              currentWeekSendovers: 'Current Week Sendovers',
              lastFiveWeeks: 'Last Five Weeks Sendouts',
              lastWeek: 'Last Week Sendouts',
              placementRatio: 'Sendout to Placement Ratio',
              previousWeekFour: 'Previous Week 4 Sendouts',
              previousWeekThree: 'Previous Week 3 Sendouts',
              previousWeekTwo: 'Previous Week 2 Sendouts'
            }
          },
          footer: {
            title: '* Update Times:',
            metrics: {
              calls: {
                title: 'Calls',
                content:
                  '(Not Connected, Connected & Total) - Updated daily with data from the previous day. On Mondays, it includes data from Friday through Sunday.'
              },
              inMails: {
                title: 'Inmails',
                content:
                  'Shows the average number of InMails sent per day during the current billing period.'
              },
              posts: {
                title: 'Posts',
                content:
                  'Updated daily based on the Logic Melon report generated at 5:00 AM (CST), reflecting information from the previous day.'
              },
              SOtoPL: {
                title: 'SO/PL',
                content: 'Calculated using Year-to-Date (YTD) data for Placements and Sendouts.'
              }
            }
          }
        }
      },
      dominateSheet: {
        title: 'Dominate Sheet',
        mainTabs: {
          activeInventory: 'Active Inventory',
          followUpTasks: 'Follow Up Tasks',
          interviews: 'Interviews',
          outstandingBillings: 'Outstanding Billings'
        },
        debriefingCalls: {
          title: 'Debriefing Calls'
        },
        hotCandidates: {
          headerAction: 'Show pending to be verified',
          title: 'Active Candidates'
        },
        hotInventoryStatsSummary: {
          title: 'Active Inventory Estimated Commissions'
        },
        hotJobOrders: {
          headerAction: 'Show pending to be verified',
          title: 'Active Job Orders'
        },
        preparationCalls: {
          title: 'Preparation Calls'
        },
        unconvertedSendovers: {
          title: 'Unconverted Sendovers'
        },
        unsignedAgreements: {
          title: 'Unsigned Agreements'
        }
      },
      activityPage: {
        title: 'Activity',
        mainTabs: {
          overview: 'Overview',
          performanceReports: 'Performance Reports'
        },
        notFound: {
          subtitle:
            "This team or recruiter can't be found. Please verify the URL is correct. If the problem persists, contact FortPac Support.",
          title: '404 - Page Not Found'
        }
      },
      teamPage: {
        path: 'Overview',
        title: 'Team'
      },
      finance: {
        financialProductivityStatsSummary: {
          title: 'Financial YTD Overview'
        },
        healthDistribution: {
          subtitle:
            'Healthy Index is based on the difference between Draw Balance and Outstanding Production + Cash In',
          title: 'Financial Health Distribution (YTD)'
        },
        lowHealthMembersByTeam: {
          subtitle: '',
          title: 'Low Health Members by Team'
        },
        teamMembersHealth: {
          title: 'Team Members by Health Status'
        },
        productionCashInByMonth: {
          subtitle:
            'Healthy Index is based on the difference between Draw Balance and Outstanding Production + Cash In',
          title: 'Production and Cash in by Month'
        },
        PDAByTenure: {
          title: 'Per Desk Average YTD by Tenure'
        }
      },
      activity: {
        gaugeStats: {
          scaleLabel: '50%',
          percentage: '{value}%'
        },
        activeInventory: {
          subtitle: 'Inventory with Activity in the last 30 days',
          title: 'Active Inventory'
        },
        recruiter: {
          tabs: {
            overview: 'Overview',
            pilGrowth: 'PIL Growth',
            activity: 'Activity'
          }
        },
        assignedInventory: {
          subtitle: `Amount of Inventory in the recruiter's PIL`,
          title: 'Assigned Inventory'
        },
        calls: {
          severalContacts: 'Several Contacts',
          severalCompanies: 'Several Companies'
        },
        callsGauge: {
          title: 'Calls',
          chart: {
            goal: 'Calls Goal',
            members: 'Members on Goal',
            footerLabel: 'Goal is 60 daily or 2 hrs phone time'
          }
        },
        callsTrends: {
          title: 'Calls'
        },
        notConnectedCallsTrends: {
          title: 'Not Connected Calls'
        },
        notConnectedHourlyCallsTrends: {
          title: 'Not Connected Hourly Calls Trend'
        },
        notConnectedPhoneTimeTrends: {
          title: 'Not Connected Calls Phone Time (Minutes)'
        },
        financialStatsSummary: {
          title: 'Financial YTD'
        },
        inMailsGauge: {
          title: 'Avg Daily InMails',
          chart: {
            goal: 'InMails Goal',
            members: 'Members on Goal',
            footerLabel:
              'Goal progress averages 20 InMails/day. (LinkedIn has a 30-hr. report delay. Last updated at 1:30 PM)'
          }
        },
        goalsProgressInTime: {
          title: 'Goals Progress Through Time'
        },
        activityTrends: {
          title: 'Hourly Call Trends'
        },
        inMailsTrends: {
          title: 'InMails'
        },
        peopleReachedGauge: {
          title: 'People Reached',
          chart: {
            goal: 'Ppl Reached Goal',
            members: 'Members on Goal',
            footerLabel: 'Goal is 100 daily'
          }
        },
        peopleReachedTrends: {
          title: 'People Reached'
        },
        phoneTimeGauge: {
          title: 'Phone Time (Hours)',
          chart: {
            goal: 'Time (Hrs) Goal',
            members: 'Members on Goal',
            footerLabel: 'Goal is 60 daily or 2 hrs phone time'
          }
        },
        phoneTimeTrends: {
          title: 'Phone Time (Minutes)'
        },
        pil: {
          title: 'PIL',
          industries: 'Industries'
        },
        placementsStatsSummary: {
          title: 'Placements YTD'
        },
        productivityStatsSummary: {
          title: 'Productivity YTD'
        },
        lastDateStatsSummary: {
          title: 'Last Sendout and Placement Dates'
        },
        productionTrends: {
          title: 'Production'
        },
        weeklyActivityStatsSummary: {
          title: `Current Week Activity`
        },
        weeklyInventoryGrowthStatsSummary: {
          title: `Current Week Inventory Growth`
        },
        inventoryAdded: `{entity} Added`,
        overallPerformance: {
          title: 'Overall Performance',
          footer: {
            overallPerformanceFooter: {
              metrics: {
                calls: {
                  title: 'Calls',
                  goals: 'Daily 60, Weekly 300'
                },
                phoneTime: {
                  title: 'Phone Time',
                  goals: 'Daily 2 hrs, Weekly 10 hrs'
                },
                bulks: {
                  title: 'Bulks',
                  goals: 'Daily 1, Weekly 5'
                },
                peopleReached: {
                  title: 'People Reached',
                  goals: 'Daily 100, Weekly 500'
                },
                inMails: {
                  title: 'InMails',
                  goals: 'Daily 20, Weekly 100'
                },
                posts: {
                  title: 'Posts',
                  goals: '100 live at all times with 5 new postings daily'
                }
              }
            },
            infoLabel: '* Since tracked'
          }
        },
        weeklyProductivityStatsSummary: {
          title: `Current Week Productivity`
        }
      },
      overview: {
        title: 'Overview'
      },
      feedbackNotes: {
        title: 'HR & Performance Documentation',
        drawer: {
          tabs: {
            feedbackNotes: 'HR & Performance Documentation',
            supportActivity: 'Support Activity'
          },
          form: {
            mainAction: 'New Documentation',
            titles: {
              addNewNote: 'Add New Documentation',
              editNote: 'Edit Documentation'
            },
            alert: {
              success: 'The Documentation was {action} successfully',
              error: 'Something went wrong!'
            },
            placeholders: {
              reachOutReason: 'Reason to Reach Out *',
              addressableIssues: 'Issues to Address *',
              contract: 'Contract *'
            }
          },
          deleteNote: {
            title: 'Delete Note',
            confirmationDialog: {
              title: 'Delete Note',
              message: 'Are you sure you want to delete this Note?'
            },
            alerts: {
              success: 'Note {action} successfully',
              error: 'Error {action} Note'
            }
          }
        },
        supportActivity: {
          form: {
            success: 'Activity Notes were updated successfully',
            error: {
              somethingWrong: 'Something went wrong!'
            }
          }
        },
        emptyState: {
          notes: {
            title: 'No Documentations to Show',
            subtitle: 'To create the first one, click the “+ New Documentation” button'
          },
          supportActivity: {
            title: 'No Support Activity to Show'
          }
        },
        noteDetailsDrawer: {
          title: 'Note Details',
          fields: {
            contract: 'Contract',
            createdAt: 'Created on',
            createdBy: 'Created by',
            description: 'Description',
            issuesToAddress: 'Issues to Address',
            updatedAt: 'Last Updated on',
            updatedBy: 'Updated by'
          }
        },
        activityDetailsDrawer: {
          title: 'Activity Details',
          fields: {
            contact: 'Contact',
            content: 'Content',
            createdAt: 'Date',
            direction: 'Direction',
            duration: 'Duration',
            notes: 'Notes',
            updatedAt: 'Last Updated on',
            updatedBy: 'Updated by'
          }
        },
        tableActions: {
          create: 'Create Documentation',
          view: 'View Documentation Logs'
        },
        savedInEmployeeFileAt: {
          title: "Recruiter's File",
          checkBox: "Save event in Recruiter's File",
          columnLabel: "Saved in Recruiter's File",
          inProcess: "The note is being uploaded to Recruiter's file",
          success: "The note was successfully uploaded to Recruiter's file at {date}",
          error: "The note could not be stored in Recruiter's file but an email was sent to HR"
        }
      },
      productionBoard: {
        title: 'Production Board',
        byRoster: 'Roster',
        byWeek: 'Production By Week',
        ytdProduction: 'YTD Production',
        trackingProduction: 'Tracking Production',
        widgets: {
          mtdProduction: 'MTD Production',
          mtdTracking: 'MTD Tracking',
          ytdProduction: 'YTD Production',
          ytdTracking: 'YTD Tracking'
        },
        notes: {
          updates: 'Production updates every 10 minutes'
        }
      },
      fallOffsBoard: {
        title: 'Fall Offs Board',
        byWeek: 'Fall Offs By Week',
        byRecruiter: 'Fall Offs By Recruiter',
        widgets: {
          count: 'FallOffs',
          total: 'Total Fall Offs Amount',
          totalProduction: 'Total Production',
          percentage: 'FallOff % of Production'
        }
      },
      commissionsBoard: {
        title: 'Commissions & Payroll Board',
        leftTableTitle: 'Pay Periods',
        rightTableTitle: 'Transactions',
        updatedInfo: 'Information updates every 10 minutes.'
      },
      shared: {
        supportActivities: {
          call: 'Call',
          email: 'Email'
        }
      }
    },
    dailyPlan: {
      title: 'Daily Plan',
      subtitle: 'Organize your day and focus on your actions to achieve your goals.',
      moreOptions: {
        title: 'More Options'
      },
      tableAction: {
        add: 'Add Actions',
        reschedule: 'Reschedule Actions',
        archive: 'Archive Actions',
        restore: 'Restore Actions'
      },
      emptyState: {
        tasks: {
          subtitle:
            'Organize your desk and boost your daily producivity.\nTo add an action, click the + New Action button.',
          title: 'No Actions Added'
        },
        changeLogs: {
          title: 'No Changelogs'
        }
      },
      header: {
        action: 'Show Completed Actions',
        title: 'Action Plan'
      },
      callTypes: {
        liveCall: 'Live Call',
        voicemail: 'Voicemail',
        unableToConnect: 'Unable to Connect'
      },
      drawer: {
        emptyState: 'Something went wrong loading the task details. Please try again.',
        taskDetails: {
          changeLog: {
            title: 'Changelog'
          },
          callText: 'Call / Text',
          reachOutTo: 'Reach out to',
          title: 'Action Details & Results',
          form: {
            titles: {
              taskResults: 'Action Results'
            },
            alert: {
              error: 'Something went wrong!',
              success: 'Details Updated Successfully'
            },
            labels: {
              connectionResult: 'Connection Result',
              comments: 'Comments',
              customOutcome: 'Enter Outcome *',
              outcome: 'Outcome',
              selectTaskOutcome: 'Select Action Outcome',
              status: 'Status'
            }
          }
        },
        form: {
          titles: {
            createTask: 'Create Action',
            editTask: 'Edit Action'
          },
          alert: {
            error: 'Something went wrong!',
            success: 'Action {action} successfully'
          },
          multipleCreation: {
            total: 'contacts selected for action creation.',
            contactsTotal: 'contacts selected',
            restrictionsByTaskType: {
              marketCandidate:
                'Actions will be created only for the Hiring Authorities, Hiring Authority Prospects and Companies in your contact selection.',
              recruitJobOrder:
                'Actions will be created only for the Candidates and Candidate Prospects in your contact selection.'
            },
            taskLimitExceeded:
              'Actions can be created for up to {maxItemsLimit} records at once. Your selection of {totalSelected} records will only create actions for the first {maxItemsLimit} selected.'
          },
          labels: {
            atLeastOneContact: 'At least one Contact must be selected',
            candidate: 'Candidate',
            candidateProspect: 'Candidate Prospect',
            comments: 'Comments',
            company: 'Company',
            contactSelection:
              'Select at least one Contact to create the action (added individually for each selected Contact).',
            hiringAuthority: 'Hiring Authority',
            hiringAuthorityProspect: ' Hiring Autority Prospect',
            interview: 'Select an interview to obtain its insights.',
            reachOut: "Select who you're going to reach out",
            searchProject: 'Search Project',
            selectReachOutTo: "Select who you're going to reach out to *",
            sendoutDetails: 'Sendout Details',
            taskDetails: 'Action Details',
            taskType: 'Action Type'
          },
          placeholders: {
            comments: 'Comments',
            jobOrderPosition: 'Search Job Order by Position, Job Function or Company *',
            otherTask: 'Enter Other Action *',
            selectCandidate: 'Search Candidate by Name or Email *',
            selectCompany: 'Search Company by Name *',
            selectContact: 'Search Contact by Name or Email *',
            selectInterview: 'Search Interview by Candidate, Company or Job Order Title *',
            selectSearchProject: 'Select Search Project *',
            setDate: 'Set Date *',
            setTime: 'Set Time',
            taskType: 'Action Type *'
          },
          errors: {
            pastDates: 'Action date must be the current date or later'
          }
        }
      },
      actionButton: 'New Action',
      filters: {
        callType: 'Call Type',
        contactType: 'Contact Type',
        outcome: 'Outcome',
        taskStatus: 'Action Status',
        taskTypes: 'Action Type',
        myDailyPlan: 'My Daily Plan',
        leadership: {
          recruiters: 'Daily Plan to Show',
          teams: 'Select a Team',
          selector: {
            recruiters: 'Select a Daily Plan'
          }
        }
      },
      outcomes: {
        otherOutcome: 'Other Outcome'
      },
      rescheduleActions: {
        decisionDialog: {
          title: 'Reschedule Actions'
        },
        success: 'Actions Rescheduled Successfully',
        failTitle: 'Reschedule Failed',
        fail: 'Something went wrong. Please try again.',
        limitExceeded:
          'Actions can be rescheduled for up to {maxItemsLimit} records at once. Your selection of {totalSelected} records will only reschedule actions for the first {maxItemsLimit} selected.',
        rescheduleOptions: {
          rescheduleForTomorrow: {
            title: 'Reschedule for Tomorrow',
            description:
              'The selected actions will be moved to tomorrow at the same time. Are you sure you want to reschedule these actions?'
          },
          customReschedule: {
            title: 'Custom Reschedule'
          }
        }
      },
      archiveActions: {
        drawer: {
          title: 'Archived Actions',
          table: {
            title: 'No Archived Actions to show',
            subtitle: "You haven't archived any actions. Once you do, they'll appear here"
          }
        },
        decisionDialog: {
          archive: {
            title: 'Archive Actions',
            description:
              'The selected Actions will be available for 30 days in the Archived list before automatic deletion. Are you sure you want to archive these actions?',
            success: 'Actions Archived Successfully'
          },
          restore: {
            title: 'Restore Actions',
            description:
              'The selected Actions will be restored to the time they were initially scheduled for. Are you sure you want to restore these Actions?',
            success: 'Actions Restored Successfully'
          },
          limitExceeded:
            'Actions can be {mode}d for up to {maxItemsLimit} records at once. Your selection of {totalSelected} records will only {mode} Actions for the first {maxItemsLimit} selected.'
        }
      },
      taskStatus: {
        completed: 'Completed',
        pending: 'Pending',
        overdue: 'Overdue'
      }
    },
    messageCenter: {
      title: 'Text Messages',
      newMessage: 'New Message',
      refreshConversations: 'Refresh Conversations',
      selectConversations: 'Select Conversations',
      markAs: 'Mark as {status}',
      newConversation: {
        searchContact: 'Search for an existing contact',
        sendMessage: 'Send Message',
        searchInputLabel: 'Search by Name, Phone Number or Email',
        sendTo: 'Send text message to'
      },
      chat: {
        goToLastMessage: 'Jump to latest',
        refresh: 'Refresh Conversation'
      },
      attachments: {
        attachment: 'Attachment',
        received: '(Attachment received)',
        sent: '(Attachment sent)'
      },
      emptyState: {
        title: 'No Messages to Show',
        subtitle: 'Once you send a text message, it will be shown here.',
        unselected: 'Click on any message to view its details',
        conversations: {
          title: 'No conversations yet',
          subtitle: 'Click on New Message to start a conversation'
        },
        search: {
          title: 'No conversations found',
          subtitle: 'Try a different keyword'
        }
      },
      error: {
        default: 'Error sending this message',
        sendingMessage: 'Error while sending message',
        optedOut: 'This number has opted out from our messages',
        invalidPhone: 'Invalid phone number'
      },
      messageComposer: {
        placeholder: 'Write a message (Shift + Enter for new line)',
        tooltip: 'Send Message',
        sendMessageLabel: 'Send Message Button',
        exceeded: 'Message too large. Limit: {limit} characters or 3 MB with attachments.',
        attachment: {
          tooltip: {
            upload: 'Upload Attachment',
            remove: 'Remove Attachment'
          }
        },
        templates: {
          count: '{count} Templates',
          empty: 'No templates to show',
          new: 'New Template',
          search: 'Search Template',
          title: 'Text Message Templates',
          tooltip: 'Use Template',
          viewTemplates: 'View Templates',
          form: {
            title: 'Template Name',
            titlePlaceholder: 'Enter Template Name',
            content: 'Template Content',
            contentPlaceholder: 'Enter Template Content',
            cancel: 'Cancel',
            save: 'Save Template',
            useTemplate: 'Use Template',
            copy: 'Copy',
            edit: 'Edit',
            delete: 'Delete'
          },
          deleteConfirm: {
            title: 'Delete Template "{title}"?',
            message: 'This action cannot be undone.',
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'No, cancel'
          },
          alerts: {
            error: 'Error {action} template'
          }
        }
      }
    },
    ai: {
      generators: {
        title: 'AI Assistant - {title}',
        primaryButton: 'Use this content',
        alert:
          'AI may occasionally generate errors or inaccurate results. Please always review and verify information before using it.',
        inputs: {
          instructionsLabel: 'Additional Instructions',
          instructionsPlaceholder: 'Enter additional instructions'
        },
        actions: {
          regenerate: 'Regenerate',
          generateWithAI: 'Generate with AI',
          openAssistant: 'Open Training Assistant'
        },
        roleplay: {
          actionButton: 'AI Roleplay',
          title: 'Roleplay Simulation',
          callGoals: 'Call Goals',
          callVerbiages: {
            description:
              'Use these structured conversation guides to navigate candidate interactions effectively. Each section contains proven questions and handling techniques.',
            marketing: 'Marketing Call Verbiages',
            recruiting: 'Recruiting Call Verbiages'
          },
          error: {
            body: 'Failed to generate the Roleplay',
            title: 'Error Generating Roleplay'
          },
          experienceOptions: {
            junior: '0 - 3 years',
            medium: '4 - 7 years',
            expert: '8 - 15 years',
            veteran: '15+ years'
          },
          feedback: {
            info: 'Your feedback will be available shortly after the call ends.',
            view: 'View Feedback'
          },
          feedbackDrawer: {
            title: 'AI Roleplay Logs',
            tabs: {
              aiInsights: {
                alert: {
                  message:
                    'Something went wrong while reporting this issue. Please try again or contact Fortpac Support if the problem persists.',
                  title: 'Error Reporting Issue'
                },
                describeIssueLabel: 'Describe the issue in detail...',
                emptyState: {
                  actionButton: 'Refresh',
                  title: 'Feedback is not ready yet',
                  subtitle: 'Please wait until the Feedback is ready.'
                },
                error: 'Error loading feedback',
                feedbackSummary: 'Feedback Summary',
                goals: 'Call Goals Achieved: {goalsMet}',
                issueReported: 'Simulation Issue Reported',
                noFeedback: 'No feedback available',
                reportAnIssue: 'Report an issue',
                somethingWrong: 'Something wrong with this simulation?',
                title: 'AI Insights',
                whatToImprove: 'What to Improve',
                whatWentWell: 'What Went Well'
              },
              transcript: {
                callEnded: 'Call Ended',
                emptyState: {
                  actionButton: 'Refresh',
                  title: 'Transcript is not ready yet',
                  subtitle: 'Please wait until the Transcript is ready.'
                },
                error: 'Error loading transcript',
                noTranscript: 'No transcript available',
                title: 'Transcript'
              },
              presentation: {
                emptyState: {
                  actionButton: 'Refresh',
                  title: 'Feedback is not ready yet',
                  subtitle: 'Please wait until the Feedback is ready.'
                },
                noPresentation: 'Presentation not available.',
                title: 'Presentation'
              }
            }
          },
          form: {
            mainAction: 'Launch Call on RingCentral',
            sections: {
              callTargetOptions: {
                callHiringAuthority: {
                  title: 'Call a Hiring Authority',
                  label: 'Select a Candidate to present'
                },
                callCandidate: {
                  title: 'Call a Candidate',
                  label: 'Select a Job Order to recruit for'
                }
              },
              roleplayProfile: {
                title: 'Set Roleplay Profile',
                labels: {
                  entityType: 'Select {entityType} *',
                  experience: 'Experience *',
                  industrySpecialty: 'Industry: Specialty *',
                  subspecialty: 'Subspecialty',
                  title: 'Title *'
                }
              },
              roleplaySetup: {
                title: 'Roleplay Setup',
                labels: {
                  whoAreYouCalling: 'Who are you calling?'
                }
              },
              difficulty: {
                title: 'Difficulty',
                options: {
                  random: {
                    label: 'Random',
                    description: 'A difficulty level will be randomly selected'
                  },
                  easy: {
                    label: 'Easy',
                    description:
                      'Cooperative and direct. Willing to listen with minimal objections.'
                  },
                  medium: {
                    label: 'Medium',
                    description:
                      'Cautious but professional. Requires convincing and asks clarifying questions.'
                  },
                  hard: {
                    label: 'Hard',
                    description:
                      'Skeptical and evasive. Challenges assumptions and gives vague answers.'
                  }
                }
              }
            }
          },
          infoAlert: 'This call will be analyzed to help you improve your performance.',
          listPage: {
            roleplayLogs: 'Roleplay Logs',
            subtitle: 'Practice calls with AI Agents via RingCentral.',
            title: 'AI Roleplay Center',
            manualDrawer: {
              presentation: {
                title: 'Presentation',
                subtitle: {
                  recruiting:
                    'Paste the Job Order presentation your Director gave you. Use it to guide your pitch during the call.',
                  marketing:
                    'Paste the Candidate presentation your Director gave you. Use it to guide your pitch during the call.'
                },
                placeholder: 'Paste Presentation Here...',
                requiredError:
                  'Presentation is required. Please paste the presentation before continuing.'
              }
            },
            modal: {
              title: 'Roleplay Setup',
              subtitle: 'Select an option for this call',
              whoAreYouCallingPlaceholder: 'Who are you calling?',
              setupOptions: {
                fromInventory: {
                  title: 'From Inventory',
                  subtitle: 'Select existing inventory to set up your call.'
                },
                manual: {
                  title: 'Manual Setup',
                  subtitle: 'Set up a call using your own presentation and industry details.'
                }
              }
            }
          },
          metrics: {
            avgDurationSeconds: 'Avg. Duration',
            title: 'Your Global Feedback',
            totalCalls: 'Calls',
            totalDurationSeconds: 'Phone Time'
          },
          subtitle: 'Practice calls with AI Agents via RingCentral.',
          selectScenario: 'Select a Roleplay Scenario',
          selectDifferentScenario: 'Select Different Scenario',
          scenarios: {
            callCandidate: {
              goals: {
                confirmWilligness: 'Confirm willingness to change jobs.',
                gatherInformation:
                  'Gather information on the Candidate to later market them (Taking a Candidate Data Sheet).'
              },
              jobOrderInfo: {
                title: 'Job Order to Recruit:',
                resetSelection: 'Select Different Job Order'
              },
              labelPrefix: "Candidate's",
              subtitle: 'Gather information, gauge interest, set next steps.',
              title: 'Cold Call (Candidate)'
            },
            callHiringAuthority: {
              candidateInfo: {
                title: 'Candidate to Present:',
                resetSelection: 'Select Different Candidate'
              },
              goals: {
                confirmHiringAuthorityInterest:
                  'Confirm if the Hiring Authority is looking to fill a position.',
                gatherJobOrderInformation:
                  'Gather information on the Job Order to later recruit (Taking an Assignment Sheet).',
                obtainFeeAgreementSignature:
                  'Get the Hiring Authority to agree on signing the Fee Agreement.'
              },
              labelPrefix: 'Hiring Authority',
              subtitle: 'Get Job Order details, sign a Fee Agreement.',
              title: 'Cold Call (Hiring Authority)'
            }
          },
          startNewSimulation: 'Start New Simulation',
          success: {
            answerCall: 'Please answer your RingCentral line to start the Roleplay.',
            phoneShouldRing: 'Your phone should ring in a few seconds.'
          }
        },
        presentationsMaker: {
          actionButton: 'Presentation Maker',
          error: {
            body: 'Failed to generate the presentation',
            title: 'Error Generating Presentation',
            rate: {
              message: 'Failed to rate this generated response. Please contact Fortpac Support.',
              title: 'Rating Error'
            }
          },
          title: 'Presentations Generator',
          types: {
            bulk: 'Bulk',
            call: 'Call Script',
            industryBriefing: 'Industry Briefing',
            linkedinAIPrompt: 'Linkedin AI Prompt',
            linkedinInMail: 'Linkedin InMail',
            linkedinJobPost: 'Job Posting',
            text: 'Text Message'
          },
          candidates: {
            header: `Select an Option`,
            candidateToPresent: `Candidate to Present: {candidateName}`
          },
          jobOrders: {
            header: `Select an Option`,
            jobOrderToPresent: `Job Order to Present: {jobOrderTitle}`
          },
          defaultState: {
            title: 'Ready to Work!',
            subtitle: 'Select an option to start'
          },
          warningCloseDialog: {
            title: 'Closing AI assistant',
            message:
              'To avoid losing your work, copy and store it elsewhere before closing the assistant. Are you sure you want to close the AI Assistant?',
            actions: {
              discardAndExit: 'Discard & Exit',
              cancel: 'Back to AI Assistant'
            }
          }
        },
        assistant: {
          chatHistory: 'Chat History',
          title: 'Training Assistant',
          subHeader: 'Your guide to FortPac, tools, and the gpac recruiting workflow.',
          start: 'Start a new conversation:',
          sidebar: {
            newChat: 'New Chat',
            searchChat: 'Search Chat',
            menu: {
              optionsAriaLabel: 'Chat options',
              rename: 'Rename',
              pinChat: 'Pin chat',
              unpinChat: 'Unpin chat',
              delete: 'Delete'
            },
            deleteConfirm: {
              title: 'Delete chat?',
              message: 'This will delete {chatTitle}.',
              helper: 'This action cannot be undone.',
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel'
            }
          },
          search: {
            searching: 'Searching conversations...',
            default: 'Start typing to search your conversations.',
            empty: 'No conversations found.',
            clear: 'Clear Search'
          },
          models: {
            select: 'Select AI Agent',
            pacGPT: {
              title: 'PacGPT',
              description: 'FortPac Knowledge and Recruitment Resources'
            },
            gpacUTrainer: {
              title: 'gpac U Trainer',
              description: 'Recruiting 101 Knowledge'
            }
          },
          composer: {
            placeholder:
              'What do you want to know? You can ask about recruiting workflows, Fortpac, Tools, Resources, etc.'
          },
          emptyConversation: {
            title: 'What would you like to ask?',
            subtitle: 'Start the conversation by typing your question below.',
            emptyMessage: '(no response received)'
          },
          errors: {
            sendMessage: 'Error sending message',
            failedAction: 'Failed to {action} conversation'
          }
        },
        prospectingAssistant: {
          actionButton: 'Sourcing',
          drawer: {
            title: ' Prospecting and Sourcing',
            composerPlaceholder:
              'i.e.: Find construction companies with 50+ employees in Texas or Find me superintendents in Atlanta, Georgia',
            rightPanelTitle: 'Results',
            history: 'History',
            newChat: 'New Chat',
            metaData: {
              contactsFound: '{count} contacts found',
              companiesFound: '{count} companies found'
            },
            table: {
              columns: {
                fullName: 'Full Name',
                linkedinUrl: 'Linkedin URL',
                headline: 'Headline',
                title: 'Title',
                department: 'Department',
                location: 'Location',
                companyName: 'Company',
                companyIndustry: 'Company Industry',
                companyLocationHqFullAddress: 'Company HQ Address',
                companyLinkedinUrl: 'Company Linkedin URL',
                companyWebsite: 'Company Website',
                company: {
                  name: 'Name',
                  linkedinUrl: 'LinkedIn URL',
                  website: 'Website',
                  sizeRange: 'Size Range',
                  industry: 'Industry',
                  hqCountry: 'Country'
                }
              },
              emptyState: {
                title: 'No Records Found'
              }
            },
            warningCloseDialog: {
              title: 'Closing AI Prospecting Assistant',
              message:
                'To avoid losing your work, copy and store it elsewhere before closing the assistant. Are you sure you want to close the AI Prospecting Assistant?',
              actions: {
                discardAndExit: 'Discard & Exit',
                cancel: 'Back to AI Assistant'
              }
            },
            emptyConversation: {
              title: 'Find contacts or companies',
              subtitle:
                "Describe the contact or company you're looking for in plain english — role, location, industry, etc."
            }
          },
          modal: {
            goSearchAction: 'Go Search',
            placeholder: 'i.e. find commercial construction superintendents in Sioux Falls, SD',
            searchTextTemplate: '{title} in {location}',
            subtitle:
              'Search Prospects in the popular professional networking platform and create a Search Project',
            title: ' Prospecting and Sourcing'
          }
        }
      }
    }
  }
});

export default strings;
